export const bundledLocales = {
  'zh-CN': {
    Common: {
      retry: '重试',
      loading: '加载中',
      loadingVideo: '视频获取中...',
      loadingResources: '正在加载资源',
      loadingResourcesDescription: '初次加载资源可能需要较多时间 请耐心等待',
      switchLanguage: '切换语言',
      logout: '退出登录',
      loadFailed: '加载失败',
      pageErrorTitle: '出错了 500',
      pageErrorDescription: '页面出现了问题，请刷新或重试。',
      upload: '上传',
      insert: '插入',
      richTextPlaceholder: '请输入内容',
      uploadingPleaseWait: '上传中 请稍后...',
      yes: '是',
      no: '否',
      noLiveStream: '暂无直播流',
      enabled: '已启用',
      disabled: '已停用',
      enable: '启用',
      disable: '停用',
      realmProfile: {
        unavailableTitle: '当前渠道暂不可用',
        unavailableDescription: '请确认访问地址或联系管理员，稍后重试。',
        renderFailedTitle: '页面加载失败',
        renderFailedDescription: '页面内容暂时无法显示，请稍后重试。',
      },
      tenantSelector: {
        add: '添加',
        addShared: '添加共享租户',
        available: '可选择租户',
        cancel: '取消',
        choose: '选择共享租户',
        confirm: '确定',
        deselectAll: '取消全选',
        deselectCurrent: '取消当前页',
        edit: '编辑',
        external: '外部租户',
        externalSelectedCount: '外部租户：{{count}} 个',
        itemUnit: '项',
        itemsUnit: '项',
        moveLeft: '移回可选租户',
        moveRight: '加入已选租户',
        noData: '暂无数据',
        remove: '移除',
        removeAll: '全部移除',
        removeTenant: '移除 {{name}}',
        searchPlaceholder: '搜索租户',
        selectAll: '全选',
        selectCurrent: '选择当前页',
        selectInvert: '反选当前页',
        selected: '已选择租户',
        selectedCount: '已选择 {{count}} 个租户',
        unselected: '未选择',
      },
      tenantVisibility: {
        cross: '指定租户',
        internal: '仅内部',
        label: '可见范围',
        public: '公共可见',
        selectedCount: '{{count}} 个协作租户',
        unresolvedCount: '另有 {{count}} 个租户已不可用',
        visibleTenants: '可见租户',
      },
      stringArrayInput: {
        add: '添加一项',
        addNamed: '添加{{item}}',
        delete: '删除此项',
        deleteNamed: '删除{{item}}',
        placeholderNamed: '请输入{{item}}',
      },
      documentSource: {
        addURL: '通过 URL 添加',
        confirm: '确定',
        fileTooLarge: '资料大小不能超过 128 MiB',
        importFailed: '网络资料转存失败，请检查地址后重试',
        invalidURL: '请输入有效的 HTTPS 资料地址',
        more: '更多资料来源',
        networkDocument: '网络资料',
        remove: '移除资料',
        replace: '替换资料',
        upload: '上传资料',
        uploading: '正在上传，请完成后再保存',
        urlPlaceholder: '输入 HTTP(S) 资料地址',
        urlTitle: '通过 URL 添加资料',
        view: '查看',
      },
    },
    ObjectSchema: {
      manage: 'Schema 管理',
      version: {
        retryLoad: '重试加载',
        lazyFailureDescription: '可视化编辑器加载失败，当前版本草稿未丢失。',
        editorUnavailable: 'Schema 编辑器暂时不可用',
        resourceLoadFailed: 'Designable 资源加载失败',
        missingID: '缺少 SchemaVersion ID',
        detailLoadFailed: '版本详情加载失败',
        editorLoading: 'Schema 编辑器仍在加载',
        validationFailed: 'Schema 校验失败',
        exportFailed: 'Schema 导出失败，请修复编辑器错误后重试',
        exportInvalidJSON: 'Schema 导出结果不是合法 JSON',
        draftSaveFailed: 'SchemaVersion 保存失败',
        draftSaved: 'SchemaVersion 已保存',
        viewTitle: '查看版本 r{{revision}} · {{title}}',
        editTitle: '编辑版本 r{{revision}} · {{title}}',
        cancel: '取消',
        close: '关闭',
        saveDraft: '保存',
        initFailed: '版本编辑器初始化失败',
        retry: '重试',
        revision: '修订号',
        title: '标题',
        titleI18n: '标题多语言',
        remark: '备注',
        basicInfo: '基础信息',
        jsonSchema: 'JSON Schema',
        loadingEditor: '正在按需加载可视化编辑器…',
        preparingComponents: '正在准备安全组件资源…',
        listLoadFailed: 'SchemaVersion 列表加载失败',
        operationFailed: '版本操作失败',
        publishedSuccess: '版本已发布',
        deprecatedSuccess: '版本已废弃',
        draftDeleted: '草稿已删除',
        manage: '版本管理',
        clone: '克隆为新草稿',
        cloneFailed: '克隆草稿失败，当前编辑内容未改变',
        cloned: '已克隆为新草稿',
        createDraft: '新建空白草稿',
        createDraftFailed: '新建草稿失败',
        draftCreated: '空白草稿已创建',
        untitledDraft: '未命名 Schema',
        conflictRecovered: '草稿已被其他操作更新；已刷新保存基线并保留本地编辑，请确认后重试',
        draftIdentityChanged: '当前草稿已被替换，旧编辑器已关闭；请刷新后重新打开新草稿',
        metadataSaveFailed: '版本备注保存失败',
        refresh: '刷新',
        status: '状态',
        published: '已发布',
        deprecated: '已废弃',
        draft: '草稿',
        updatedAt: '更新时间',
        actions: '操作',
        edit: '编辑',
        view: '查看',
        publish: '发布',
        delete: '删除',
        deprecate: '废弃',
        publishDescription: '发布后 Schema 正文不可再修改。',
        publishConfirm: '确认发布这个版本？',
        deleteConfirm: '确认删除这个草稿？',
        deprecateDescription: '废弃后仍保留既有 Object 引用，但不能再被新绑定。',
        deprecateConfirm: '确认废弃这个版本？',
      },
      objectData: {
        switchToJSON: '切换到 JSON',
        renderFailureDescription: '内容草稿仍然保留，可切换到 JSON 模式继续查看和修复。',
        renderFailed: 'Schema UI 渲染失败',
        defaultContent: '默认内容',
        localeContent: '{{locale}} 内容',
        currentBinding: '当前绑定',
        bindableLoadFailed: '可绑定 SchemaVersion 加载失败',
        loadFailed: 'Object 内容加载失败',
        schemaLoadFailed: 'SchemaVersion 定义加载失败',
        invalidFields: '内容中存在无效字段，请修复后再保存',
        rootObjectRequired: '默认内容和多语言内容必须是 JSON object',
        localeObjectRequired: '每个多语言内容都必须是 JSON object',
        stale: '内容已被其他操作更新，请复制当前 JSON 后刷新远端快照',
        saveFailed: 'Object 内容保存失败',
        saved: 'Object 内容已保存',
        schemaUnavailable: '当前绑定没有可用 Schema，只能使用 JSON 模式。',
        deleteLocaleConfirm: '确认删除 {{locale}} 内容？',
        deleteLocale: '删除 {{locale}}',
        manage: '数据管理',
        save: '保存',
        title: '数据管理 · {{title}}',
        binding: '关联 SchemaVersion',
        unboundPlaceholder: '不绑定，仅使用 JSON',
        notConformantTitle: '当前内容不符合已绑定 Schema',
        notConformantDescription: '原内容已完整保留，可在 JSON 或 UI 模式修复；保存时仍以后端校验为准。',
        bindingDiagnostic: '绑定诊断：{{status}}',
        bindingDiagnosticDescription: 'Schema 异常不会遮挡或清空 Object 内容，当前仅开放 JSON 模式。',
        schemaDiagnostic: 'Schema 诊断',
        addLanguage: '新增语言',
        addLocale: '新增 locale',
        invalidJSON: '请输入合法的 JSON object',
        retry: '重试',
      },
    },
    FileViewer: {
      title: '文件预览',
      invalid: '文件地址不可用',
      loading: '文件加载中…',
      timeout: '文件加载超时',
      openExternal: '在新窗口打开',
    },
    Update: {
      later: '稍后处理',
      refreshNow: '立即刷新',
      shell: {
        title: '发现应用新版本',
        description: '智教空间基础资源已有更新，刷新后即可使用最新版本。',
      },
      module: {
        title: '发现业务模块新版本',
        description: '{{modules}} 已发布新版本。为避免新旧模块混用，请刷新后继续使用。',
      },
    },
    Account: {
      brand: {
        title: '启云智教',
        subtitle: '平台用户身份与租户员工身份分层认证，进入租户后再加载工作台和控制台。',
      },
      login: {
        title: '登录',
        subtitle: '登录平台账号后选择要进入的租户。',
        phoneMode: '手机验证',
        passwordMode: '密码登录',
        noMethod: '暂无可用登录方式',
        noMethodDescription: '请联系平台管理员启用至少一种登录方式。',
        account: '账号',
        accountPlaceholder: '请输入手机号',
        accountRequired: '请输入手机号',
        phonePrefix: '区号',
        phone: '手机号',
        phonePlaceholder: '请输入手机号码',
        phoneRequired: '请输入手机号码',
        phoneMin: '手机号至少 8 位',
        password: '密码',
        passwordPlaceholder: '请输入密码',
        passwordRequired: '请输入密码',
        passwordMin: '密码至少 8 位',
        code: '验证码',
        codePlaceholder: '请输入验证码',
        codeRequired: '请输入验证码',
        codeMin: '验证码至少 4 位',
        sendCode: '获取验证码',
        agreement: '我已阅读并同意《用户协议》《隐私政策》',
        agreementPrefix: '我已阅读并同意',
        userAgreement: '《用户协议》',
        privacyPolicy: '《隐私政策》',
        agreementConfirmTitle: '请先阅读并同意协议',
        agreementConfirmContent: '登录前需要同意《用户协议》和《隐私政策》，是否同意并继续登录？',
        agreementConfirmOk: '同意并继续',
        agreementConfirmCancel: '暂不同意',
        submit: '登录',
        oauthDivider: '其他登录方式',
      },
      captcha: {
        imageTitle: '请输入图形验证码',
        imagePlaceholder: '请输入图形验证码',
        imageAlt: '图形验证码',
        getImage: '获取验证码',
        retryAfter: '{{seconds}} 秒后重试',
      },
      tenant: {
        title: '选择登录单位',
        checking: '正在校验账号',
        checkingDesc: '请稍候，正在确认当前登录状态。',
        loadError: '账号校验失败',
        loadErrorDesc: '暂时无法确认当前账号，请重试。',
        subtitle: '您的帐号关联了 {{count}} 个单位，请选择当前登录单位',
        backLogin: '返回登录',
        switchLoginMethod: '切换登录方式',
        switchLoginError: '切换登录方式失败，请重试',
        switchLoginConfirmTitle: '确认切换登录方式？',
        switchLoginConfirmDesc: '切换后将退出当前单位与启云平台账号，需要重新登录才能继续使用。',
        switchLoginConfirm: '确认切换',
        enabled: '可进入',
        disabled: '已停用',
        enter: '进入',
        empty: '当前账号暂无可进入的租户',
        join: '申请加入租户',
        disabledTitle: '提示',
        disabledMessage: '学校被禁用，请联系学校管理员',
      },
      oauth: {
        loading: '正在完成第三方登录',
        waitDesc: '请稍候，认证成功后会自动跳转。',
        error: '第三方登录失败',
        errorDesc: '未能完成授权登录，请返回登录页重试。',
        backLogin: '返回登录页',
      },
      oidc: {
        loginTitle: '正在确认登录',
        loginDescription: '请稍候，正在继续访问已授权的应用。',
        consentTitle: '正在授权',
        consentDescription: '请稍候，授权完成后会自动返回应用。',
        logoutTitle: '正在退出账号',
        logoutDescription: '请稍候，正在结束应用登录会话。',
        invalidChallenge: '授权链接无效',
        invalidChallengeDesc: '链接缺少必要的授权参数，请从原应用重新发起登录或退出。',
        flowError: '授权流程未完成',
        flowErrorDesc: '授权请求暂时失败或返回地址无效，请重试；仍失败时请从原应用重新发起。',
        authorizationFailed: '授权失败',
        authorizationFailedDesc: '授权服务器未能完成当前请求。',
        logoutSuccessTitle: '已成功退出账号',
        logoutSuccessDesc: '应用登录会话已退出，您可以安全地关闭页面或返回登录。',
        backHome: '返回首页',
        logoutPlatform: '退出启云平台账号',
        platformLogoutSuccess: '已退出登录',
        platformLogoutError: '退出启云平台账号失败',
      },
      join: {
        title: '加入租户',
        checking: '正在校验邀请',
        checkingDesc: '请稍候，正在确认您的登录状态和邀请信息。',
        invalid: '邀请链接无效',
        invalidDesc: '邀请链接缺少必要信息、当前账号未绑定手机号或链接已损坏。',
        loadError: '邀请信息加载失败',
        loadErrorDesc: '暂时无法确认当前账号，请重试。',
        schoolTitle: '加入学校',
        confirmDesc: '确认后将使用当前登录账号绑定受邀员工身份。',
        schoolName: '学校名称',
        submit: '加入学校',
        submitError: '未能加入学校。请确认邀请未过期、当前账号手机号与邀请信息一致。',
        addTitle: '创建学校',
        addDescription: '我们会为你匹配专属顾问协助完成',
        consultant: '商务顾问联系：',
        consultantPhone: '136 6488 8888',
        consultantName: '张先生',
        application: '提交申请：',
        copyLink: '复制链接',
        copySuccess: '复制成功',
        copyFailed: '复制失败，请手动复制',
        openLink: '立即前往',
        back: '返回',
      },
      tenantRoute: {
        authChecking: '正在校验登录状态',
        authError: '登录状态校验失败',
        authErrorDesc: '暂时无法确认当前账号和租户身份，请重试。',
        workspace: '租户工作台入口',
        admin: '租户控制台入口',
        subtitle: '工作台和控制台不属于本次认证账号基础信息迁移范围，当前先保留租户内层路由承载能力。',
        business: '查看业务包',
        staff: '当前员工',
        menuLoading: '正在获取当前员工菜单',
        menuReady: '已获取当前员工可见菜单',
        menuSubtitle: '登录租户员工身份后，按当前权限加载可进入菜单。',
        menuError: '菜单获取失败',
        menuErrorDesc: '请确认当前员工登录态、租户 ID 和网关接口可用。',
        menuEmpty: '当前员工暂无可见菜单',
        menuLeaf: '暂无下级菜单',
        adminInitializing: '管理台资源初始化中',
        adminLoading: '正在加载管理台权限',
        adminError: '管理台权限加载失败',
        adminErrorDesc: '无法从权限服务获取当前员工的管理菜单。',
      },
    },
    Workspace: {
      title: '租户工作台',
      logoAlt: '工作台',
      staffFallback: '租户员工',
      expand: '展开菜单',
      collapse: '收起菜单',
      notice: '通知',
      personalMenu: '个人中心菜单',
      personalMenuEmpty: '暂无个人中心菜单',
      menuLoading: '正在获取工作台和个人中心菜单',
      menuSubtitle: '工作台一级菜单由当前员工的 workspace 权限驱动。',
      menuError: '工作台菜单获取失败',
      menuErrorDesc: '请确认当前员工登录态、租户 ID 和网关接口可用。',
      menuEmpty: '当前员工暂无可见的工作台菜单',
      current: '当前',
      entryReady: '已进入 {{name}}',
      eLearningUnavailable: '云研社页面尚未开放',
      eLearningUnavailableDesc: '当前地址已被识别，但对应业务页面尚未完成迁移，请返回工作台。',
      eLearningBack: '返回工作台',
    },
    ELearningReview: {
      status: {
        approved: '已审批',
        assigned: '已分配',
        cancelled: '已取消',
        failed: '执行失败',
        planCompleted: '已结束',
        taskCompleted: '已提交',
        expired: '已过期',
        inProgress: '进行中',
        notStarted: '未开始',
        overdue: '已超时',
        pendingApproval: '待审批',
        pendingTask: '未提交',
        rejected: '审核驳回',
        returned: '已退回',
        suspended: '已暂停',
        unassigned: '未分配',
        withdrawn: '已撤销',
      },
      planDetail: '计划详情',
      taskDetail: '任务详情',
      retry: '重试',
      detailLoadFailed: '详情加载失败',
      courseTag: '课程标签',
      keyword: '关键词',
      emptyDetail: '暂无详情',
      planName: '计划名称',
      planStatus: '计划状态',
      taskProgress: '任务完成率',
      startDate: '开始日期',
      endDate: '结束日期',
      completed: '已完成',
      unsubmitted: '未提交',
      inReview: '审核中',
      rejected: '审核驳回',
      planRemark: '计划说明',
      tags: '标签',
      taskList: '任务列表（{{count}}）',
      emptyTasks: '暂无任务',
      taskName: '任务名称',
      resourceName: '资源名称',
      reviewer: '审校人',
      submissionStatus: '提交状态',
      approvalStatus: '审批状态',
      remark: '备注',
      attachments: '附件',
      participating: '我参与的',
      followed: '我关注管理的',
      uncompleted: '未完成',
      expiredCurrent: '已过期',
      totalTasks: '总任务数',
      totalCompletedTasks: '总任务完成数',
      totalProgress: '总任务完成率',
      taskKeyword: '请输入任务名称',
      allTaskStatus: '全部任务状态',
      allApprovalStatus: '全部审校状态',
      planKeyword: '请输入计划名称',
      allPlanStatus: '全部计划状态',
      allProgress: '全部进度',
      query: '查询',
      reset: '重置',
      listLoadFailed: '审校列表加载失败',
      sourcePlan: '来源计划：{{name}}',
      timeRange: '起止时间：{{start}} - {{end}}',
      goToReview: '去审校',
      withdrawReview: '撤回审核',
      withdrawReviewTitle: '确认撤回',
      withdrawReviewConfirm: '确定要撤回该审批吗？',
      withdrawReviewSucceeded: '撤回成功',
      withdrawReviewFailed: '撤回失败',
      viewDetail: '查看详情',
      emptyParticipating: '暂无参与任务',
      emptyFollowed: '暂无关注计划',
      noData: '暂无数据',
      content: '审校内容',
      reviewRecord: '审校记录',
      cancel: '取消',
      confirm: '确定',
      approvalMismatch: '审批与审校任务不匹配',
      approvalMismatchDesc: '当前链接中的审批 ID 不属于该审校任务，已禁止所有写操作。请返回审核中心重新进入。',
      submitConfirm: '确认提交当前审校内容并发起审批吗？',
      submitReview: '提交审校',
      withdrawConfirm: '确认撤回当前审校审批吗？',
      withdraw: '撤回审批',
      approveConfirm: '确认通过当前审校审批吗？',
      approve: '通过',
      rejectAction: '拒绝',
      rejectTitle: '拒绝审校审批',
      rejectPlaceholder: '请输入拒绝理由',
    },
    Interaction: {
      title: '资源空间',
      noAccess: '暂无权限',
      noAccessDescription: '当前账号没有可访问的资源空间页面',
      loadFailed: '资源空间加载失败',
      menu: {
        groups: {
          personal: '个人空间',
          school: '校本空间',
        },
        routes: {
          myExam: '试题',
          myFile: '资源素材',
          myNote: '笔记',
          myVideo: '课程实录',
          schoolExam: '校本题库',
          schoolResource: '校本资源',
        },
      },
      common: {
        all: '全部',
        cancel: '取消',
        confirm: '确定',
        retry: '重试',
        edit: '编辑',
        publish: '发布',
        delete: '删除',
        download: '下载',
        close: '关闭',
        loading: '加载中',
        nextPage: '下一页',
        pageNumber: '第 {{page}} 页',
        previousPage: '上一页',
        source: '来源',
        empty: '暂无数据',
        resetFilters: '重置筛选',
        searchContent: '输入内容AI帮搜',
        resourceLoadFailed: '资源加载失败，请重试',
        networkFailed: '网络连接失败，请重试',
        noAvailableTextbook: '当前账号未配置可用教材',
        chapterDirectoryLoadFailed: '章节目录加载失败',
        uploadFailed: '上传失败',
        registrationUnknown: '业务登记结果未知',
        invalidFileType: '无效的文件类型',
        uploadCredentialFailed: '获取上传地址失败',
        uploadHTTPFailed: '上传失败：HTTP {{status}}',
        uploadNetworkFailed: '网络错误，上传失败',
        selectAvailableTextbook: '请选择可用教材',
      },
      resourceSelector: {
        allCategories: '全部分类',
        category: '分类',
        categoryLoadFailed: '资源分类加载失败，请重试',
        completeTextbook: '请完整选择学段、学科、教材版本和教材',
        currentPath: '当前路径',
        directoryEmpty: '当前范围暂无可用目录',
        directoryLoadFailed: '资源目录加载失败，请重试',
        fileSize: '大小',
        noAvailableTextbook: '当前账号暂无可用教材',
        personalEmpty: '当前目录暂无可选资源',
        personalListLoadFailed: '个人资源加载失败，请重试',
        personalRoot: '个人文件根目录',
        personalSpace: '个人空间',
        publishedAt: '发布时间',
        resourceMaterial: '资源素材',
        resourceName: '资源名称',
        resourceType: '资源类型',
        schoolEmpty: '当前目录暂无可选校本资源',
        schoolListLoadFailed: '校本资源加载失败，请重试',
        schoolResource: '校本资源',
        schoolSpace: '校本空间',
        searchResource: '输入资源名称搜索',
        selectDirectory: '请选择目录',
        selectedCount: '当前已选择 {{count}} 个资源',
        selectStage: '请选择学段',
        selectSubject: '请选择学科',
        selectTextbook: '选择教材',
        selectTextbookPlaceholder: '请选择教材',
        selectTextbookVersion: '请选择教材版本',
        stage: '学段',
        subject: '学科',
        switchTextbook: '切换教材',
        syncResource: '同步资源',
        teachingOptionsLoadFailed: '教材选项加载失败，请重试',
        textbook: '教材',
        textbookVersion: '教材版本',
        title: '选择资源',
        topicLoadFailed: '专题加载失败，请重试',
        unconfiguredTextbook: '未配置教材',
        updatedAt: '修改时间',
      },
      exam: {
        addTitle: '添加试题',
        addSucceeded: '添加试题成功',
        addingHint: '当前添加 1 道试题，复合题可包含多个小题',
        approvalPending: '审批申请已提交，等待审批',
        batchDelete: '批量删除',
        cannotClearChildTeaching: '不能一次清空已有子题的全部教学标签',
        cannotClearRootTeaching: '不能一次清空已有题目的全部教学标签',
        childCustomTagsBlocked: '该子题含自定义标签，暂不能同时修改教学信息',
        creationPayloadLocked: '新增结果未确认，请刷新个人题库核对；当前载荷已锁定',
        creationReviewed: '已核对，允许再次新增',
        creationStillUnknown: '该新增结果仍未确认，请先刷新个人题库核对后再操作',
        creationUnknown: '新增试题结果未知，请先刷新个人题库核对',
        deleteConfirm: '确定删除选择的试题吗？',
        deleteFailed: '删除试题失败',
        deleteQuestion: '删除试题',
        deleteRetry: '删除试题失败，请重试',
        deleteSucceeded: '删除试题成功',
        detailLoadFailed: '题目详情加载失败，请重试',
        editRequestFailed: '编辑试题请求失败',
        editSucceeded: '编辑试题成功',
        editTitle: '编辑试题',
        editingHint: '正在编辑 1 道试题',
        title: '试题',
        search: '搜索题干',
        kind: '题型',
        difficulty: '难度',
        stage: '学段',
        grade: '年级',
        subject: '学科',
        knowledge: '知识点',
        year: '年份',
        itemsPerPage: '条/页',
        invalidQuestionID: '题目标识无效',
        listLoadFailed: '个人题库加载失败，请重试',
        missingPublishMetadata: '试题「{{name}}」未同时绑定教材章节和知识点，请先补充后再发布',
        publishFailed: '审批提交失败，请重试',
        publishPayloadLocked: '审批提交结果未确认，请刷新审核中心核对；当前载荷已锁定',
        publishStillUnknown: '该审批提交结果仍未确认，请先在审核中心核对后再操作',
        publishValidationFailed: '题目发布条件校验失败，请重试',
        requestUnconfirmed: '请求结果未确认，请刷新后核对',
        rootCustomTagsBlocked: '该题含自定义标签，暂不能同时修改教学信息',
        saveFailed: '保存试题失败，请重试',
        saveChanges: '保存修改',
        saveQuestion: '保存试题',
        selectAnswer: '请选择答案',
        selectDifficulty: '请选择难度',
        selectOneQuestion: '请至少选择一道试题',
        selectTopicNodeFirst: '请先选择专题节点',
        selectYear: '请选择年份',
        totalItems: '共 {{total}} 条',
        batchActions: '批量操作',
        add: '添加试题',
        empty: '暂无试题',
        publishTitle: '发布试题',
        normalPublishHint: '普通发布沿用每道题已有的教材章节与知识点。',
        choiceJudge: '选择判断',
        content: '题目内容',
        contentPlaceholder: '请填写题目内容，例如：以下哪位是《红楼梦》的作者？',
        option: '选项',
        optionPlaceholder: '填写选项内容',
        analysis: '解析',
        analysisPlaceholder: '请输入试题解析',
        advancedFields: '完整题型字段',
        mediaHint: '在完整题型字段中管理题目图片与附件',
        insertImage: '上传图片',
        selectorSearch: '输入题干关键词搜索',
        selectorEmpty: '暂无可选择试题',
        selectorLoadFailed: '个人题库加载失败',
        answer: '答案',
        collapseDetails: '收起详情',
        correct: '正确',
        difficultyNames: {
          easy: '容易',
          hard: '困难',
          normal: '一般',
        },
        expandDetails: '展开详情',
        incorrect: '错误',
        kindNames: {
          blank: '填空',
          calc: '计算',
          cloze: '完形填空',
          drawing: '作图',
          essay: '写作',
          inquiry: '实验探究',
          judge: '判断',
          matching: '匹配',
          multi: '多选',
          ordering: '排序',
          reading: '阅读理解',
          short: '简答',
          single: '单选',
        },
        leftColumn: '左栏',
        noAnalysis: '暂无解析。',
        rightColumn: '右栏',
        sourceNames: {
          personal: '个人题库',
          platform: '平台资源',
          school: '校本转存',
        },
        teachingNames: {
          grade: {
            'junior-1': '七年级',
            'junior-2': '八年级',
            'junior-3': '九年级',
            'junior54-1': '六年级',
            'junior54-2': '七年级',
            'junior54-3': '八年级',
            'junior54-4': '九年级',
            'primary-1': '一年级',
            'primary-2': '二年级',
            'primary-3': '三年级',
            'primary-4': '四年级',
            'primary-5': '五年级',
            'primary-6': '六年级',
            'primary54-1': '一年级',
            'primary54-2': '二年级',
            'primary54-3': '三年级',
            'primary54-4': '四年级',
            'primary54-5': '五年级',
            'secondary-vocational-1': '中职一年级',
            'secondary-vocational-2': '中职二年级',
            'secondary-vocational-3': '中职三年级',
            'senior-1': '高一',
            'senior-2': '高二',
            'senior-3': '高三',
          },
          stage: {
            high: '高中',
            junior: '初中',
            junior54: '初中五四制',
            kindergarten: '幼儿园',
            primary: '小学',
            primary54: '小学五四制',
            'secondary-vocational': '中职',
            senior: '高中',
            'special-education': '特殊教育',
          },
          subject: {
            art: '艺术',
            biology: '生物学',
            chemistry: '化学',
            chinese: '语文',
            english: '英语',
            geography: '地理',
            history: '历史',
            information: '信息技术',
            japanese: '日语',
            math: '数学',
            music: '音乐',
            paint: '美术',
            physics: '物理',
            politics: '思想政治',
            science: '科学',
            sports: '体育与健康',
            technology: '通用技术',
          },
        },
        listSeparator: '；',
        noSelectedQuestions: '暂无已选择试题，请先添加试题',
        publishApprovalStarted: '已发起发布审批，请在审核中心查看进度',
        publishReviewed: '已核对，允许再次提交',
        publishSucceeded: '发布成功',
        publishToTopic: '发布到专题资源',
        publishTopicHint: '不选择专题时，试题需已绑定教材章节和知识点；选择专题后可直接提交发布审批。',
        publishUnknown: '审批提交结果未知，请先在审核中心核对',
        selectedQuestionCount: '已选择 {{count}} 道试题',
        selectedTopicNodes: '已选择专题节点：{{names}}',
        untitledQuestion: '未命名试题',
        updatedAt: '更新于 {{time}}',
        editor: {
          addBlank: '添加填空',
          addChild: '添加小题',
          addClozeBlank: '添加空格',
          addItem: '添加选项',
          addKnowledge: '添加知识点',
          addMatchingRow: '添加一行',
          addOrderingItem: '添加排序项',
          addTextbookChapters: '添加教材章节（可多选，非必填）',
          analysisPlaceholder: '请填写题目解析，支持上传图片',
          answerLabels: {
            drawing: '参考作图',
            essay: '参考立意',
            short: '参考答案',
          },
          answerPlaceholder: '请填写{{label}}，支持上传图片',
          blankAnswerPlaceholder: '第 {{index}} 空答案',
          blankAnswers: '填空答案',
          blankIndex: '第 {{index}} 空',
          chapterLoading: '章节加载中...',
          childContent: '小题 {{index}} 题干',
          childContentPlaceholder: '第 {{index}} 小题题干',
          childIndex: '小题 {{index}}',
          childKind: '小题 {{index}} 题型',
          children: '小题',
          clozeOptions: '空格选项',
          contentLabels: {
            content: '题目内容',
            passage: '短文',
            readingMaterial: '阅读材料',
            stem: '题干',
            writingRequirements: '写作要求',
          },
          contentPlaceholders: {
            blank: '请填写题目，用「插入填空」加入 ＿，例如：《静夜思》作者是 ＿。',
            calc: '填写大题背景与图示，下方逐小问录入。',
            cloze: '粘贴短文，用「插入填空」在需要挖空处加入 ＿。',
            drawing: '填写作图要求并插入初始图形或坐标系。',
            essay: '填写写作要求、材料与字数限制。',
            inquiry: '填写实验探究背景、条件与图示。',
            judge: '请填写判断陈述，例如：《岳阳楼记》作者是范仲淹。',
            matching: '填写匹配要求，例如：补齐物质与用途之间的连线。',
            multi: '请填写题目内容，例如：下列属于唐宋八大家的有？',
            ordering: '填写排序要求，例如：根据故事内容将下列句子排序。',
            reading: '粘贴阅读篇章正文，可插入配图。',
            short: '请填写题目，例如：简述光合作用的过程。',
            single: '请填写题目内容，例如：以下哪位是《红楼梦》的作者？',
          },
          correctAnswer: '正确答案',
          deleteBlank: '删除第 {{index}} 空',
          deleteChild: '删除小题 {{index}}',
          deleteOption: '删除选项 {{option}}',
          deleteOrderingItem: '删除排序项 {{option}}',
          dragOrderingItem: '拖动排序项 {{option}}',
          dragToReorder: '拖动调整顺序',
          fillOption: '填写选项',
          groups: {
            choice: '选择判断',
            composite: '复合大题',
            fill: '填空类',
            interactive: '操作互动',
            other: '其他',
            subjective: '主观解答',
          },
          kindNames: {
            blank: '填空题',
            calc: '计算题',
            cloze: '完形填空',
            drawing: '作图题',
            essay: '写作题',
            inquiry: '实验探究',
            judge: '判断题',
            matching: '匹配题',
            multi: '多选题',
            ordering: '排序题',
            reading: '阅读理解',
            short: '简答题',
            single: '单选题',
          },
          imageOptions: '图片选项',
          imageOnly: '仅支持图片文件',
          imageUploadFailed: '图片上传失败，请重试',
          insertBlank: '插入填空',
          leftPlaceholder: '填写左栏内容',
          matchingAnswer: '第 {{index}} 项匹配答案',
          matchingItems: '匹配项',
          materialLoading: '教材加载中...',
          moveChildDown: '下移小题 {{index}}',
          moveChildUp: '上移小题 {{index}}',
          optionImageAlt: '{{option}} 选项',
          optionImagePlaceholder: '上传图片',
          orderingPlaceholder: '填写排序内容',
          question: '试题',
          rightPlaceholder: '填写右栏内容',
          selectMaterials: '请选择教材（可多选）',
          selectPlaceholder: '请选择',
          setAsAnswer: '设为答案',
          setBlankAnswer: '设第 {{blank}} 空 {{option}} 为答案',
          sortItems: '排序项',
          teachingInfo: '教学信息',
          textbookChapters: '教材章节',
          textOptions: '文字选项',
          unmatched: '未匹配',
          unset: '未设置',
        },
      },
      folder: {
        currentTarget: '当前目标：{{path}}',
        root: '我的资源',
        namePlaceholder: '新文件夹名称',
        submitCreate: '新建',
        cancel: '取消',
        create: '+ 新建文件夹',
        empty: '当前目录暂无子文件夹',
        cannotSelectSelf: '（不能选择自身或后代）',
      },
      file: {
        alreadyInTarget: '所选文件已在目标目录',
        actions: '操作',
        addedResourceCount: '已添加 {{count}} 个资源',
        approvalSubmitted: '已提交审批',
        batchDelete: '批量删除',
        batchPublish: '批量发布',
        archiveProcessing: '目录压缩包正在生成，请稍后重新导出',
        cannotClearTeachingTags: '当前后端无法可靠清空全部教学标签，请至少保留一项或取消编辑',
        copiedCount: '已复制 {{count}} 项',
        copyPartialUnknown: '已复制 {{count}} 项，当前项结果未确认；已停止后续复制，请刷新目标目录核对',
        copyStillUnknown: '所选文件存在复制结果未确认项，请刷新目标目录核对；确认未生成后刷新页面再操作',
        copySucceeded: '复制成功',
        copyUnknown: '复制结果未确认，请刷新目标目录核对；当前操作已锁定，避免生成重复副本',
        createFolderFailed: '新建文件夹失败',
        createFolderSucceeded: '新建文件夹成功',
        createdAs: '已创建为 {{name}}',
        customTagsBlocked: '该文件含自定义标签，暂不能同时修改教学信息',
        deleteConfirm: '删除后不可恢复，确定继续吗？',
        deleteFailed: '删除失败',
        deleteFile: '删除文件',
        deleteSucceeded: '删除成功',
        document: '文档',
        earliestModified: '最早修改',
        export: '导出',
        exportPreparationFailed: '目录导出准备失败',
        exportPreparationRetry: '导出准备失败，请重试',
        file: '文件',
        folderLoadFailed: '目录加载失败，请重试',
        folderNamePlaceholder: '请输入文件夹名称',
        image: '图片',
        itemsPerPage: '条/页',
        media: '音视频',
        modifiedAt: '修改时间',
        moreActions: '{{name}}更多操作',
        mountChapterFirst: '请先挂载教材章节',
        name: '名称',
        newFolder: '新建文件夹',
        operationSucceeded: '操作成功',
        other: '其他',
        personalRoot: '我的资源',
        personalUpload: '个人上传',
        preview: '预览',
        publishToTopic: '发布到专题资源',
        publishTopicHint: '不勾选时发布到资源已挂载的章节；勾选后可额外选择多个专题节点。',
        recentlyModified: '最近修改',
        remove: '移除',
        rename: '重命名',
        editMountedChapters: '编辑挂载章节',
        editMountedChaptersFailed: '挂载章节更新失败',
        editMountedChaptersSucceeded: '挂载章节更新成功',
        editMountedChaptersTitle: '编辑挂载章节 - {{name}}',
        save: '保存',
        schoolSync: '校本资源同步',
        selectFilesFirst: '请先选择要操作的文件',
        selectedResourceCount: '已选择 {{count}} 个资源',
        selectTopicFirst: '请先选择专题',
        selectTopicNodes: '请选择专题节点（可跨专题多选）',
        selectTopics: '请选择专题（可多选）',
        size: '大小',
        sizeExceeded: '{{type}}不能超过 {{limit}}，请重新选择',
        teachingInfo: '教学信息',
        totalItems: '共 {{total}} 条',
        uploadResource: '上传资源',
        uploadDropMultiple: '将文件拖拽到此处，或点击选择文件（可多选）',
        videoFile: '视频文件',
        batchActions: '批量操作',
        listView: '列表视图',
        sort: '排序',
        resourceNamePlaceholder: '请输入资源名称',
        summary: '资源摘要',
        remark: '备注',
        clearTagsBlocked: '当前后端不支持可靠清空全部教学标签，本次只保存可确认字段。',
        copyTo: '复制到',
        copyHint: '当前真实契约只支持单项复制；重名使用自动后缀。',
        moveTo: '移动到',
        moveBlocked: '服务端尚未在写入时复核目标归属与祖先环，真实移动暂不可提交。',
        publishTitle: '发布',
        publishHint: '发布入口必须选择非空可访问分类；后端尚无幂等 requestID，未知结果不会自动重试。',
        publishCategory: '请选择发布分类',
        publishChapterHint: '教学章节由资源现有标签带入，提交时由服务端再次校验分类与租户范围。',
        uploadDrop: '点击或拖拽文件到此区域上传',
        uploadPath: '上传目录：{{path}}',
        selectedSubfolder: '已选择子目录',
        uploadRegistrationUnknown: '部分文件登记结果未知；请刷新当前目录核对，禁止直接重复提交',
        commonSummary: '统一资源摘要',
        commonRemark: '统一备注',
        uploadHint: '最多并发 3 个上传；S3 失败项删除后重新选择。',
        addResource: '添加资源',
        selectorTip: '仅展示文件资源，文件夹仅用于定位目录。',
        selectorSearch: '输入资源名称搜索',
        selectorEmpty: '当前目录暂无可添加的文件资源',
        selectorLoadFailed: '资源列表加载失败，请重试',
        selectedResources: '已添加资源',
        selectedTip: '切换目录不会丢失已添加项',
        clearSelected: '清空全部',
        selectedEmpty: '暂无已添加资源',
        uploadPathLabel: '上传路径',
        downloadWindowBlocked: '浏览器阻止了下载窗口，请允许弹窗后重试',
        folderNameRequired: '文件夹名称不能为空',
        listLoadFailed: '个人文件加载失败，请重试',
        movedCount: '已移动 {{count}} 项',
        moveFailed: '移动失败，请重试',
        movePartialFailed: '已移动 {{count}} 项，后续移动失败；请刷新后重试',
        movePartialUnknown: '已移动 {{count}} 项，当前项结果未确认；已停止后续移动，请刷新核对',
        moveSucceeded: '移动成功',
        moveUnknown: '移动结果未确认，请刷新后核对',
        noPublishableFiles: '所选内容中没有可发布的文件',
        publishApprovalSubmitted: '已提交 {{count}} 个资源的发布审批，请等待审批',
        publishPayloadLocked: '审批提交结果未确认，请先在审核中心核对；当前载荷已锁定',
        publishStillUnknown: '该审批提交结果仍未确认，请先在审核中心核对后再操作',
        registrationStillUnknown: '文件「{{name}}」登记结果仍未确认，请刷新目标目录核对后再操作',
        registrationUnconfirmed: '文件登记未确认成功，请先刷新目录核对后再处理',
        renamedAs: '已重命名为 {{name}}',
        renameFailed: '重命名失败',
        renameSucceeded: '重命名成功',
        requestUnconfirmed: '请求结果未确认，请刷新后核对',
        resourceMissingChapter: '资源「{{name}}」未挂载章节，请先在“编辑挂载章节”中完成配置',
        selectEntriesFirst: '请先选择要操作的文件或文件夹',
        selectPublishCategoryForEach: '请为每个资源选择发布分类',
        selectTopicResourceNodeFirst: '请先选择专题资源节点',
        siblingPaginationStalled: '同级文件分页未推进',
        siblingQueryFailed: '同级文件查询失败',
        targetLoadFailed: '目标目录读取失败，请重试',
        uploadSucceeded: '上传资源成功',
        waitForUploads: '请等待全部文件上传完成；失败项请删除后重新选择',
      },
      note: {
        collapseSidebar: '收起侧边栏',
        expandSidebar: '展开侧边栏',
        create: '新建笔记',
        moreActions: '{{title}}，更多操作',
        delete: '删除笔记',
        deleteTitle: '确定删除“{{title}}”吗？',
        deleteContent: '删除后当前无法恢复，未保存的修改也会一并丢失。',
        deleteSucceeded: '笔记已删除',
        deleteFailed: '删除笔记失败，请重试',
        deleteUnknown: '删除结果未确认，请刷新列表核对',
        selectFirst: '选择一篇笔记开始编辑',
        assistant: 'AI 助手',
        title: '笔记标题',
        bodyPlaceholder: '请输入笔记内容…',
        saveFailedRetry: '保存失败，重试',
        helpful: '有帮助',
        unhelpful: '无帮助',
        prompt: '请输入问题',
        stop: '停止',
        send: '发送',
        optimizationAssistant: '笔记优化助手',
        closeOptimizationAssistant: '关闭笔记优化助手',
        optimizationPrompt: '请输入你的笔记优化需求...',
        group: {
          today: '今天',
          recent: '最近 30 天',
          earlier: '更早',
        },
        noAdditionalText: '无附加文本...',
        unnamed: '未命名笔记',
        untitled: '无标题笔记',
        optimizationPromptEmpty: '请帮我优化《{{title}}》这篇笔记，使结构更清晰、表达更准确。',
        optimizationPromptWithContent: '请帮我优化《{{title}}》这篇笔记，保留核心含义，提升结构、表达和重点层次：\n{{content}}',
        imageOnly: '仅支持图片文件',
        imageSizeExceeded: '图片大小不能超过 10MB',
        imageURLMissing: '图片上传成功但未返回访问地址',
        titleSaveFailed: '标题保存失败',
        bodySaveFailed: '正文保存失败',
        saveStillFailed: '笔记保存仍然失败，请重试或明确放弃修改',
        previousCreationUnknown: '上次新建结果未知，请先核对刷新后的笔记列表',
        creationUnknownRefreshed: '新建结果未知，已刷新列表；核对后才能再次创建',
        creationFailed: '新建笔记失败',
        creationReviewed: '已核对，允许再次创建',
        creationUnknownVerify: '新建结果未知，请先在刷新后的列表中核对是否已创建',
        aiIntro: '我可以根据当前笔记优化结构、提炼重点、润色表达，并生成更清晰的笔记版本。',
        startOptimization: '基于当前笔记开始优化',
        thinking: '正在思考…',
        noReply: '尚未生成回答',
        retryAnswer: '重试回答',
        retrySync: '重试同步',
        regenerate: '重新生成',
        stayOnCurrent: '留在当前笔记',
        saveFailureContent: '最新内容尚未保存。可以重试保存、留在当前笔记，或明确放弃本次未保存修改。',
        discardAndLeave: '放弃修改并离开',
        retrySave: '重试保存',
        saveFailed: '笔记保存失败',
        detailLoadFailed: '笔记详情加载失败',
        aiSessionMismatch: '该 AI 会话不是当前助手的 Eino 会话，已停止续接',
        aiUnavailableForTenant: '当前租户没有可用 AI 助手',
        aiConversationSyncFailed: 'AI 会话回查失败',
        aiConversationScopeFailed: 'AI 会话范围校验失败，请刷新后重试同步',
        aiMessageSyncFailed: 'AI 消息回查失败',
        aiReplyNotPersisted: '本轮回答尚未完成持久化',
        aiConversationValidationFailed: 'AI 会话校验失败',
        aiConversationScopeChanged: 'AI 会话范围已变化，请刷新后重新进入',
        aiConversationIDMissing: 'AI 未返回可回查的内部会话 ID',
        aiConversationInitFailed: '会话初始化失败，请重试',
        aiReplyStopped: '回答已停止，可使用同一请求重试',
        aiUnavailable: 'AI 助手暂不可用',
      },
      work: {
        analyze: 'AI 分析',
        addExisting: '加入已有作品',
        search: '搜索作品名称',
        visibility: '公开范围',
        empty: '暂无可加入的作品',
      },
      video: {
        detail: '详情',
        taskName: '请输入任务名称',
        category: '选择分类',
        uploadFile: '上传文件',
        workActions: '作品操作',
        batchDelete: '批量删除',
        uploadTitle: '上传视频',
        selectMp4: '选择 MP4 文件',
        title: '视频标题',
        summary: '简介',
        remark: '备注',
        categoryField: '分类',
        courseKind: '课程类型',
        lecturer: '主讲人',
        uploadCover: '上传封面',
        uploadAttachment: '上传附件',
        uploadFailureHint: '上传失败项需删除后重选；登记结果未知时不会自动重试。',
        noPreview: '暂无可预览的视频地址',
        editTitle: '编辑视频',
        replaceCover: '更换封面',
        manageAttachments: '管理附件',
        recording: '录制记录',
        recordingSearch: '搜索录课名称',
        recordingRetentionPrefix: '系统将为你保留临时录课 ',
        recordingRetentionSuffix: ' 天，请及时处理，未处理的录课不会占用你的个人空间容量',
        cancelSelection: '取消选择',
        batchDeleteRecording: '批量删除',
        batchDeleteRecordingConfirm: '确定要删除选择的数据吗？',
        deleteRecordingConfirm: '删除后无法恢复，确定删除该录制记录吗？',
        deleteRecordingLabel: '删除{{name}}',
        deleteRecording: '删除录制记录',
        noRecordingFile: '暂无录制文件',
        selectPlayableStream: '请选择可播放的视频流',
        videoFile: '视频',
        cover: '封面',
        coverURLPlaceholder: '请输入网络图片地址（http/https）',
        useURL: '使用地址',
        lecturerPlaceholder: '请选择主讲人',
        name: '名称',
        namePlaceholder: '请输入视频资源名称',
        summaryPlaceholder: '请输入简介',
        createTimePlaceholder: '选择创建时间',
        classTime: '上课时间',
        classTimePlaceholder: '请选择开始时间',
        categoryPlaceholder: '请选择分类',
        advancedFields: '补充课程信息与附件',
        attachment: '附件',
        videoList: '视频列表',
        creatorCenter: '去创作者中心',
        kindTeaching: '教学课堂',
        kindResearch: '教研活动',
        kindOther: '其他',
        courseFamousTeacher: '名师课堂',
        courseFamousSchool: '名校课堂',
        courseSpecial: '专递课堂',
        courseTeacherTraining: '教师培训',
        courseOnlineResearch: '网络教研',
        sourceLocalUpload: '本地上传',
        sourceRecording: '录制转存',
        sourceResource: '资源转存',
        statusCancelled: '已取消',
        statusCompleted: '生成成功',
        statusFailed: '生成失败',
        statusInProgress: '生成中',
        statusPending: '等待生成',
        statusReady: '就绪',
        resourceInfo: '资源信息',
        createTime: '创建时间',
        className: '班级',
        actions: '操作',
        deleteConfirm: '确定删除选择的视频吗？',
        deleteVideo: '删除视频',
        deleteLabel: '删除{{name}}',
        newWork: '新建作品',
        selectVideoFirst: '请先选择要操作的课堂实录',
        selectDeleteFirst: '请先选择要删除的数据',
        itemsPerPage: '条/页',
        totalRecords: '总共 {{count}} 条记录',
        unnamedRecording: '未命名录制',
        recordingTime: '录制时间',
        lessonCategory: '课程分类',
        classType: '课堂类型',
        status: '状态',
        expiration: '是否过期',
        expired: '已过期',
        notExpired: '未过期',
        durationReadFailed: '无法读取视频时长',
        mp4Only: '仅支持上传 MP4 文件',
        durationReadRetry: '无法读取视频时长，请重新选择 MP4',
        imageOnly: '仅支持上传图片文件',
        reupload: '重新上传',
        selectOrDragVideo: '选择或拖拽视频文件上传',
        currentCoverURL: '当前封面地址：{{url}}',
        courseKindPlaceholder: '请选择课程类型',
        videoDetail: '视频详情',
        unknown: '未知',
        save: '保存',
        transfer: '转存',
        recordingTimeValue: '录制时间：{{value}}',
        lecturerValue: '主讲人：{{value}}',
        classValue: '班级：{{value}}',
        transferExpiredBlocked: '录制文件已过期，不能再转存或重试',
        transferIncompleteBlocked: '录制尚未完成，完成后才能转存',
        streamName: '视频流 {{index}}',
        retryStarted: '已发起重试',
        transferStarted: '已发起转存',
        recordingProcess: '录播处理',
        refreshStatus: '刷新状态',
        allStages: '全部学段',
        noUnselectedWork: '暂无未选中的作品',
        addExistingDescription: '从你已有的作品中多选，将当前课堂实录加入到这些作品中。你可以按作品名称、学科、学段等条件筛选。',
        selectStage: '请选择学段',
        allVisibility: '全部公开范围',
        visibilityInternal: '本单位',
        visibilityCross: '本单位及外部单位',
        visibilityPublic: '互联网公开',
        selectVisibility: '请选择公开范围',
        availableWork: '可选择的作品',
        invertSelection: '反选',
        selectedWork: '已选作品',
        clear: '清空',
        noSelectedWork: '暂未选择作品，请在左侧勾选作品后加入',
        networkURLApplied: '已使用网络地址',
        invalidNetworkURL: '请输入合法的网络地址',
        coverNetworkURLRequired: '请输入封面网络地址',
        continueEditing: '继续编辑',
        closeUnsavedContent: '作品表单还有未提交的修改，关闭后将无法恢复。',
        discardChanges: '放弃修改',
        closeUnsavedTitle: '确认关闭作品表单？',
        leaveUnsavedContent: '作品表单还有未提交的修改，离开后将无法恢复。',
        leaveUnsavedTitle: '确认离开作品表单？',
        selectPublishRecordingFirst: '请先选择要发布的课堂实录',
        acceptUploadAgreement: '请点击同意《资源上传服务协议》',
        agreementPrefix: '我已阅读并同意',
        uploadAgreement: '《资源上传服务协议》',
        publishWork: '发布作品',
        creationReviewed: '已核对，允许重新登记',
        creationUnknownLocked: '作品登记结果仍未确认，请先到创作者中心核对；当前载荷已锁定',
        publishTo: '发布至',
        featuredClassroom: '云研社 · 精选课堂',
        featuredClassroomDescription: '面向教师公开的课堂作品，将在「云研社-精选课堂」中展示，可按学段学科检索。',
        visibility: '公开范围',
        visibilityDescription: '该设置仅影响作品在云研社中的可见范围，不会修改你在个人资源中的原始权限。',
        selectExternalTenant: '请选择外部单位',
        workInfo: '作品信息',
        workInfoDescription: '以下信息将用于课堂在云研社中的展示，学生和教师可以据此检索和筛选。',
        workName: '作品名称',
        workNamePlaceholder: '请输入作品名称（最多50字）',
        workSummaryPlaceholder: '请输入简介（最多300字）',
        type: '类型',
        selectType: '请选择类型',
        selectCategoryFirst: '请先选择分类',
        selectSubject: '请选择学科',
        selectStageFirst: '请先选择学段',
        textbookVersion: '教材版本',
        selectTextbook: '请选择教材',
        selectKnowledge: '请选择知识点',
        selectedRecordings: '已选择的课堂实录',
        selectFromPersonalRecordings: '从「个人实录」中选择',
        add: '+ 添加',
        selectRecording: '请选择课堂实录',
        selectedVideoCount: '已选择 {{count}} 个视频',
        listLoadFailed: '视频列表加载失败，请重试',
        latestDetailLoadFailed: '最新视频详情加载失败，已保留列表中的可编辑内容',
        invalidCoverURL: '请输入合法的 http/https 封面地址',
        registrationStillUnknown: '该视频登记结果未知，请先刷新列表核对；确认未生成后删除并重新选择',
        waitForVideoUpload: '请等待视频上传完成；失败文件请删除后重新选择',
        registrationUnknown: '视频登记结果未确认，请刷新列表核对后再处理',
        uploadSucceeded: '上传视频成功',
        nameRequired: '视频名称不能为空',
        editFailed: '编辑视频失败',
        editRequestFailed: '编辑视频请求失败，请保留当前内容后重试',
        editSucceeded: '编辑视频成功',
        selectDeleteVideo: '请选择要删除的视频',
        deleteFailed: '删除失败',
        deleteUnknown: '删除结果未确认，请刷新列表核对',
        deleteSucceeded: '删除成功',
        completeUploadRequiredFields: '请完整填写主讲人、名称、分类和对应课程类型',
        completeEditRequiredFields: '请完整填写主讲人、分类和对应课程类型',
        waitForSupportingUploads: '请等待封面和附件上传完成',
        recordingListLoadFailed: '录制记录加载失败，请重试',
        recordingDetailLoadFailed: '录制详情加载失败，请重试',
        transferStillUnknown: '该转存结果仍未确认，请先刷新详情核对后再处理',
        recordingFileProcessing: '正在处理当前录制文件，请稍候',
        transferUnknown: '转存结果未确认，请刷新状态后再处理',
        selectRecordingDeleteFirst: '请选择要删除的录制记录',
        deleteProcessing: '删除请求正在处理，请稍候',
        deleteRetry: '删除失败，请重试',
        deleteSucceededRefreshFailed: '删除成功，列表刷新失败，请重试',
        existingWorkPartialFailed: '部分作品加入失败，请稍后重试',
        existingWorkPublishFailed: '作品加入失败，请稍后重试',
        existingWorkPublished: '已加入所选作品',
        creationStillUnknown: '该作品登记结果仍未确认，请先到创作者中心核对后再操作',
        creationUnknown: '作品登记结果未确认，请到创作者中心核对后再操作',
        workEditFailed: '作品最新修改保存失败，请重试',
        workDraftSaved: '作品草稿已保存',
        workPublishFailed: '作品发布失败，草稿已保留，可直接重试',
        workPublished: '作品已提交发布',
        existingWorkLoadFailed: '已有作品加载失败，请重试',
        selectExistingWork: '请选择已有作品',
        attachmentName: '附件{{index}}',
      },
      schoolExam: {
        addToPersonal: '添加到个人题库',
        chapterLoadFailed: '章节加载失败',
        cloneComingSoon: '添加到个人题库功能即将上线',
        defaultTeachingMissing: '当前账号未配置默认学段和学科',
        title: '校本题库',
        syncTab: '同步资源',
        knowledgeTab: '知识点',
        knowledgeLoadFailed: '知识点加载失败',
        listTruncated: '当前筛选结果过多，题目结构可能不完整，请缩小筛选范围',
        navigationLoadFailed: '导航加载失败',
        navigationLoading: '目录加载中',
        reselectStageSubject: '重新选择学段学科',
        searchAction: '搜索',
        selectDirectory: '请选择目录',
        selectMaterial: '请选择教材',
        selectStageSubject: '请选择学段和学科',
        selectStageSubjectTitle: '选择学段与学科',
        switchMaterial: '切换教材',
        textbookChapters: '教材章节',
        topicDirectory: '专题目录',
        topicDirectoryLoadFailed: '专题目录加载失败',
        topicQuestionBank: '专题题库',
        topicQuestionBankLoadFailed: '专题题库加载失败',
        underConstruction: '功能建设中',
        unconfiguredMaterial: '未配置教材',
        updatedAtEmpty: '更新于 -',
        cloneBlocked: '后端尚无校本题目克隆契约',
        empty: '暂无校本试题',
        previousBatch: '上一批',
        nextBatch: '下一批',
        batchLabel: '第 {{batch}} 批',
      },
      schoolResource: {
        chapterLoadFailed: '章节加载失败',
        cloneFailed: '转存失败，请稍后重试',
        cloneRenamed: '资源已转存为“{{name}}”',
        cloneSuccess: '已转存到个人资源库',
        cloneUnconfirmed: '转存结果尚未确认，请刷新个人资源库核对后再重试',
        contentSwitching: '内容切换中',
        createFolderFailed: '新建文件夹失败，请稍后重试',
        createFolderRetry: '新建文件夹失败，请重试',
        navigationLoading: '目录加载中',
        notFound: '资源不存在',
        personalLibrary: '个人资源库',
        preview: '预览',
        resourceLoading: '资源加载中',
        selectAvailableMaterial: '请选择可用教材',
        selectChapter: '请选择章节',
        selectTopicDirectory: '请选择专题目录',
        syncTab: '同步资源',
        targetLoadFailed: '个人目录加载失败',
        teachingNavigationFailed: '教学目录加载失败',
        textbookChapters: '教材章节',
        title: '校本资源',
        publishedAt: '发布时间：{{time}}',
        publishedAtEmpty: '发布时间：-',
        empty: '暂无校本资源',
        selectMaterial: '选择教材',
        cloneTitle: '转存个人资源库',
        cancel: '取消',
        confirm: '确认',
        personalRoot: '我的资源',
        newFolder: '新建文件夹',
        folderNamePlaceholder: '请输入文件夹名称',
        topicDirectory: '专题目录',
        topicNavigationFailed: '专题目录加载失败',
        topicResource: '专题资源',
        untitled: '未命名资源',
      },
      teaching: {
        stage: '学段',
        subject: '学科',
        material: '教材',
        chapter: '章节',
        knowledge: '知识点',
        knowledgeBlocked: '当前文件契约没有知识点字段，不能伪造知识点保存；学段、学科与章节可正常提交。',
        version: '请选择版本',
        mountChapter: '挂载章节',
        materialVersion: '版本',
        selectKnowledge: '请选择知识点',
        selectMaterial: '请选择教材',
        selectMaterialFirst: '请先选择教材',
        selectStage: '请选择学段',
        selectStageSubjectFirst: '请先选择学段和学科',
        selectSubject: '请选择学科',
        singleResourceHint: '单资源只能选择一个学段与学科；先选教材再选章节，仅加载已选教材的目录。',
        volume: '册别',
      },
    },
    Official: {
      nav: { products: '产品功能', help: '使用帮助' },
      actions: { workspace: '进入智教空间', signedIn: '已登录' },
      sections: {
        product: '线上线下无间共学',
        learning: '课前课后随心掌控',
        aiGrowth: 'AI 赋能无限成长',
        management: '数智决策轻松管理',
        solutions: '系统方案推动教育均衡',
      },
      product: {
        digital: { title: '数字教室', desc: '支持千人同时参与，全场景自适应网络，180P-1080P 帧率灵活切换，流畅体验不打折；无论身在何处，皆可随时开启高效协作课堂。' },
        board: { title: '共享黑板', desc: '多间教室无缝互联，师生可以在同一块黑板上流畅书写板书、轻松共享文档、桌面、PPT 等资源。让想法表达无门槛、交流零距离。' },
        save: { title: '随心存享', desc: '多屏板书自由保存分享，让知识不再随着下课而溜走。' },
      },
      learning: {
        schedule: { title: '灵活日程', desc: '多终端联动课表，可视化学生与教师时间资源，从小屏到大屏，手机电脑均可轻松发起教学课堂或教研会议。' },
        analysis: { title: '智课分析', desc: '告别教学黑箱，让每分钟的教学效果都清晰可见。智课分析将课堂互动与学情表现量化为直观数据，精准定位教学关键点。' },
        eLearning: { title: '精品课堂', desc: '通过自动化上传、分层管理和精准检索设计，构建区校数字教学资产库，将零散的教学片段转化为可学可用的长期资产。' },
      },
      ai: {
        teacher: { title: 'AI 教师助理', subtitle: '全天候的通识工作助理', desc: '在常态化教学与教务场景中，提供智能提醒、流程协同与数据总结，减负增效，促进目标达成与成长跟踪。' },
        professional: { title: 'AI 专业帮手', subtitle: '更懂你的专业教研助手', desc: '教学助手从听懂指令到读懂意图，用自然方式帮助教师调用各类教学资源与工具。' },
      },
      management: {
        supervision: { title: '常态督导 无感听评', desc: '远程巡视打破空间壁垒，一人多班同步监管，实现教学监控常态化，反馈全程留痕、数据可依。' },
        dashboard: { title: '数据驾驶舱 全局可视', desc: '校园核心指标实时聚合、动态可视，支持指标自动关联分析，精准挖掘数据背后的管理价值。' },
        devices: { title: '设备集控 降本增效', desc: '全校设备一键远程管控，故障自动告警，快速响应保障需求，降低日常运维成本。' },
      },
      solutions: {
        remote: { title: '远程互动课堂', desc: '打破校园壁垒，将中心校的优质资源实时输送到远端学校，让更多学生在同一堂云课堂中同享优质教学。' },
        resources: { title: '区域资源共享', desc: '无缝联动与沉淀，构建区域优质教学资源库，促进优质学习资源在区域内高效流通与共享。' },
        support: { title: '精准帮扶提升', desc: '深度互联教学校情，定位教学难点与薄弱环节，实现因材施教，整体提升教育质量。' },
      },
      help: { docs: '帮助文档', service: '客户服务' },
      footer: '让每一间教室连接更广阔的教学资源。',
    },
  },
  'en-US': {
    Common: {
      retry: 'Retry',
      loading: 'Loading',
      loadingVideo: 'Loading video...',
      loadingResources: 'Loading resources',
      loadingResourcesDescription: 'The initial load can take a little longer. Please wait.',
      switchLanguage: 'Switch language',
      logout: 'Sign out',
      loadFailed: 'Failed to load',
      pageErrorTitle: 'Error 500',
      pageErrorDescription: 'Something went wrong. Refresh or try again.',
      upload: 'Upload',
      insert: 'Insert',
      richTextPlaceholder: 'Enter content',
      uploadingPleaseWait: 'Uploading, please wait...',
      yes: 'Yes',
      no: 'No',
      noLiveStream: 'No live stream',
      enabled: 'Enabled',
      disabled: 'Disabled',
      enable: 'Enable',
      disable: 'Disable',
      realmProfile: {
        unavailableTitle: 'This channel is unavailable',
        unavailableDescription: 'Check the site address or contact an administrator, then try again.',
        renderFailedTitle: 'Page failed to load',
        renderFailedDescription: 'The page content cannot be displayed right now. Try again later.',
      },
      tenantSelector: {
        add: 'Add',
        addShared: 'Add shared tenants',
        available: 'Available tenants',
        cancel: 'Cancel',
        choose: 'Choose shared tenants',
        confirm: 'Confirm',
        deselectAll: 'Deselect all',
        deselectCurrent: 'Deselect current page',
        edit: 'Edit',
        external: 'External tenants',
        externalSelectedCount: 'External tenants: {{count}}',
        itemUnit: 'item',
        itemsUnit: 'items',
        moveLeft: 'Move to available tenants',
        moveRight: 'Move to selected tenants',
        noData: 'No data',
        remove: 'Remove',
        removeAll: 'Remove all',
        removeTenant: 'Remove {{name}}',
        searchPlaceholder: 'Search tenants',
        selectAll: 'Select all',
        selectCurrent: 'Select current page',
        selectInvert: 'Invert current page',
        selected: 'Selected tenants',
        selectedCount: '{{count}} tenants selected',
        unselected: 'Unselected',
      },
      tenantVisibility: {
        cross: 'Selected tenants',
        internal: 'Internal only',
        label: 'Visibility',
        public: 'Public',
        selectedCount: '{{count}} shared tenants',
        unresolvedCount: '{{count}} additional tenants unavailable',
        visibleTenants: 'Visible tenants',
      },
      stringArrayInput: {
        add: 'Add item',
        addNamed: 'Add {{item}}',
        delete: 'Delete item',
        deleteNamed: 'Delete {{item}}',
        placeholderNamed: 'Enter {{item}}',
      },
      documentSource: {
        addURL: 'Add via URL',
        confirm: 'Confirm',
        fileTooLarge: 'Document size cannot exceed 128 MiB',
        importFailed: 'Failed to import the online document. Check the URL and try again.',
        invalidURL: 'Enter a valid HTTPS document URL',
        more: 'More document sources',
        networkDocument: 'Online document',
        remove: 'Remove document',
        replace: 'Replace document',
        upload: 'Upload document',
        uploading: 'Uploading. Save after the upload completes.',
        urlPlaceholder: 'Enter an HTTP(S) document URL',
        urlTitle: 'Add document via URL',
        view: 'View',
      },
    },
    ObjectSchema: {
      manage: 'Manage Schemas',
      version: {
        retryLoad: 'Retry loading',
        lazyFailureDescription: 'The visual editor failed to load. The current draft is preserved.',
        editorUnavailable: 'The Schema editor is temporarily unavailable',
        resourceLoadFailed: 'Failed to load Designable resources',
        missingID: 'SchemaVersion ID is missing',
        detailLoadFailed: 'Failed to load version details',
        editorLoading: 'The Schema editor is still loading',
        validationFailed: 'Schema validation failed',
        exportFailed: 'Schema export failed. Fix the editor errors and retry.',
        exportInvalidJSON: 'The exported Schema is not valid JSON',
        draftSaveFailed: 'Failed to save the SchemaVersion',
        draftSaved: 'SchemaVersion saved',
        viewTitle: 'View revision r{{revision}} · {{title}}',
        editTitle: 'Edit revision r{{revision}} · {{title}}',
        cancel: 'Cancel',
        close: 'Close',
        saveDraft: 'Save',
        initFailed: 'Failed to initialize the version editor',
        retry: 'Retry',
        revision: 'Revision',
        title: 'Title',
        titleI18n: 'Title translations',
        remark: 'Remark',
        basicInfo: 'Basic Info',
        jsonSchema: 'JSON Schema',
        loadingEditor: 'Loading the visual editor on demand…',
        preparingComponents: 'Preparing safe component resources…',
        listLoadFailed: 'Failed to load SchemaVersion list',
        operationFailed: 'Version operation failed',
        publishedSuccess: 'Version published',
        deprecatedSuccess: 'Version deprecated',
        draftDeleted: 'Draft deleted',
        manage: 'Versions',
        clone: 'Clone as New Draft',
        cloneFailed: 'Failed to clone the draft. Current edits are unchanged.',
        cloned: 'Cloned as a new draft',
        createDraft: 'Create Blank Draft',
        createDraftFailed: 'Failed to create the draft',
        draftCreated: 'Blank draft created',
        untitledDraft: 'Untitled Schema',
        conflictRecovered: 'The draft changed elsewhere. The save baseline was refreshed and local edits were preserved; review and retry.',
        draftIdentityChanged: 'The current draft was replaced. The old editor was closed; refresh and reopen the new draft.',
        metadataSaveFailed: 'Failed to save version metadata',
        refresh: 'Refresh',
        status: 'Status',
        published: 'Published',
        deprecated: 'Deprecated',
        draft: 'Draft',
        updatedAt: 'Updated At',
        actions: 'Actions',
        edit: 'Edit',
        view: 'View',
        publish: 'Publish',
        delete: 'Delete',
        deprecate: 'Deprecate',
        publishDescription: 'The Schema body becomes immutable after publishing.',
        publishConfirm: 'Publish this version?',
        deleteConfirm: 'Delete this draft?',
        deprecateDescription: 'Existing Object references remain valid, but new bindings are disabled.',
        deprecateConfirm: 'Deprecate this version?',
      },
      objectData: {
        switchToJSON: 'Switch to JSON',
        renderFailureDescription: 'The content draft is preserved. Switch to JSON mode to inspect and repair it.',
        renderFailed: 'Schema UI rendering failed',
        defaultContent: 'Default Content',
        localeContent: '{{locale}} Content',
        currentBinding: 'Current binding',
        bindableLoadFailed: 'Failed to load bindable SchemaVersions',
        loadFailed: 'Failed to load Object content',
        schemaLoadFailed: 'Failed to load the SchemaVersion definition',
        invalidFields: 'The content contains invalid fields. Fix them before saving.',
        rootObjectRequired: 'Default and localized content must be JSON objects',
        localeObjectRequired: 'Each localized content value must be a JSON object',
        stale: 'The content was updated elsewhere. Copy the current JSON and refresh the remote snapshot.',
        saveFailed: 'Failed to save Object content',
        saved: 'Object content saved',
        schemaUnavailable: 'The current binding has no available Schema. Use JSON mode.',
        deleteLocaleConfirm: 'Delete {{locale}} content?',
        deleteLocale: 'Delete {{locale}}',
        manage: 'Manage Data',
        save: 'Save',
        title: 'Manage Data · {{title}}',
        binding: 'SchemaVersion',
        unboundPlaceholder: 'Unbound, JSON only',
        notConformantTitle: 'Content does not conform to the bound Schema',
        notConformantDescription: 'The original content is preserved and can be repaired in JSON or UI mode. Server validation still applies on save.',
        bindingDiagnostic: 'Binding diagnostic: {{status}}',
        bindingDiagnosticDescription: 'Schema failures never hide or clear Object content. Only JSON mode is available.',
        schemaDiagnostic: 'Schema Diagnostics',
        addLanguage: 'Add language',
        addLocale: 'Add locale',
        invalidJSON: 'Enter a valid JSON object',
        retry: 'Retry',
      },
    },
    FileViewer: {
      title: 'File preview',
      invalid: 'The file URL is unavailable',
      loading: 'Loading file…',
      timeout: 'File loading timed out',
      openExternal: 'Open in a new window',
    },
    Update: {
      later: 'Later',
      refreshNow: 'Refresh now',
      shell: {
        title: 'Application update available',
        description: 'New Smart Education Space shell resources are available. Refresh to update.',
      },
      module: {
        title: 'Module update available',
        description: '{{modules}} has a new version. Refresh to avoid mixing old and new module code.',
      },
    },
    Account: {
      brand: {
        title: 'Qiyun Smart Education',
        subtitle: 'Platform user auth and tenant staff auth are separated before loading tenant apps.',
      },
      login: {
        title: 'Sign in',
        subtitle: 'Sign in to your platform account, then choose a tenant.',
        phoneMode: 'Phone code',
        passwordMode: 'Password',
        noMethod: 'No sign-in method available',
        noMethodDescription: 'Contact the platform administrator to enable at least one sign-in method.',
        account: 'Account',
        accountPlaceholder: 'Please enter your phone number',
        accountRequired: 'Please enter your phone number',
        phonePrefix: 'Prefix',
        phone: 'Phone',
        phonePlaceholder: 'Phone number',
        phoneRequired: 'Please enter your phone number',
        phoneMin: 'Phone must be at least 8 digits',
        password: 'Password',
        passwordPlaceholder: 'Password',
        passwordRequired: 'Please enter your password',
        passwordMin: 'Password must be at least 8 characters',
        code: 'Code',
        codePlaceholder: 'Verification code',
        codeRequired: 'Please enter the verification code',
        codeMin: 'Code must be at least 4 characters',
        sendCode: 'Send code',
        agreement: 'I agree to the user agreement and privacy policy',
        agreementPrefix: 'I have read and agree to ',
        userAgreement: 'User Agreement',
        privacyPolicy: 'Privacy Policy',
        agreementConfirmTitle: 'Review and accept the agreements',
        agreementConfirmContent: 'You need to accept the User Agreement and Privacy Policy before signing in. Accept and continue?',
        agreementConfirmOk: 'Accept and continue',
        agreementConfirmCancel: 'Not now',
        submit: 'Sign in',
        oauthDivider: 'Other sign-in methods',
      },
      captcha: {
        imageTitle: 'Enter the image verification code',
        imagePlaceholder: 'Image verification code',
        imageAlt: 'Image verification code',
        getImage: 'Get verification code',
        retryAfter: 'Retry in {{seconds}}s',
      },
      tenant: {
        title: 'Choose an organization',
        checking: 'Checking your account',
        checkingDesc: 'Please wait while we verify your current session.',
        loadError: 'Failed to verify account',
        loadErrorDesc: 'The current account could not be verified. Please try again.',
        subtitle: 'Your account is linked to {{count}} organizations. Choose one to sign in.',
        backLogin: 'Back to sign in',
        switchLoginMethod: 'Use another sign-in method',
        switchLoginError: 'Unable to switch sign-in methods. Please try again.',
        switchLoginConfirmTitle: 'Switch sign-in method?',
        switchLoginConfirmDesc: 'This will sign you out of the current organization and Qiyun. You will need to sign in again.',
        switchLoginConfirm: 'Switch method',
        enabled: 'Available',
        disabled: 'Disabled',
        enter: 'Enter',
        empty: 'No tenant is available for this account',
        join: 'Request tenant access',
        disabledTitle: 'Notice',
        disabledMessage: 'This school is disabled. Please contact the school administrator.',
      },
      oauth: {
        loading: 'Completing third-party sign-in',
        waitDesc: 'Please wait. You will be redirected after authorization succeeds.',
        error: 'Third-party sign-in failed',
        errorDesc: 'Authorization could not be completed. Please try again.',
        backLogin: 'Back to sign in',
      },
      oidc: {
        loginTitle: 'Confirming sign-in',
        loginDescription: 'Please wait while access to the authorized application continues.',
        consentTitle: 'Authorizing',
        consentDescription: 'You will return to the application after authorization completes.',
        logoutTitle: 'Signing out',
        logoutDescription: 'Please wait while the application session is closed.',
        invalidChallenge: 'Invalid authorization link',
        invalidChallengeDesc: 'A required authorization parameter is missing. Start again from the original application.',
        flowError: 'Authorization was not completed',
        flowErrorDesc: 'The request failed or returned an invalid address. Retry or start again from the original application.',
        authorizationFailed: 'Authorization failed',
        authorizationFailedDesc: 'The authorization server could not complete this request.',
        logoutSuccessTitle: 'Signed out successfully',
        logoutSuccessDesc: 'The application session is closed. You may close this page or return to sign in.',
        backHome: 'Back to home',
        logoutPlatform: 'Sign out of Qiyun',
        platformLogoutSuccess: 'Signed out',
        platformLogoutError: 'Could not sign out of Qiyun',
      },
      join: {
        title: 'Join tenant',
        checking: 'Checking invitation',
        checkingDesc: 'Please wait while we verify your session and invitation.',
        invalid: 'Invalid invitation',
        invalidDesc: 'The invitation is incomplete, damaged, or the current account has no verified phone number.',
        loadError: 'Failed to load invitation',
        loadErrorDesc: 'The current account could not be verified. Please try again.',
        schoolTitle: 'Join school',
        confirmDesc: 'Your signed-in account will be linked to the invited staff identity.',
        schoolName: 'School name',
        submit: 'Join school',
        submitError: 'Unable to join. Check that the invitation is valid and matches the phone number of this account.',
        addTitle: 'Create a school',
        addDescription: 'We will match you with a dedicated advisor to complete the application',
        consultant: 'Business advisor:',
        consultantPhone: '136 6488 8888',
        consultantName: 'Mr. Zhang',
        application: 'Submit an application:',
        copyLink: 'Copy link',
        copySuccess: 'Link copied',
        copyFailed: 'Could not copy the link. Please copy it manually.',
        openLink: 'Open',
        back: 'Back',
      },
      tenantRoute: {
        authChecking: 'Checking your session',
        authError: 'Failed to verify your session',
        authErrorDesc: 'Your account and tenant session could not be verified. Please try again.',
        workspace: 'Tenant workspace entry',
        admin: 'Tenant admin entry',
        subtitle: 'Workspace and admin apps are outside this auth migration. The nested tenant router is reserved.',
        business: 'Open business modules',
        staff: 'Current staff',
        menuLoading: 'Loading current staff menus',
        menuReady: 'Current staff menus loaded',
        menuSubtitle: 'After tenant staff sign-in, visible menus are loaded by permission.',
        menuError: 'Failed to load menus',
        menuErrorDesc: 'Please check staff session, tenant ID, and gateway availability.',
        menuEmpty: 'No visible menu is available for this staff',
        menuLeaf: 'No child menus',
        adminInitializing: 'Initializing admin resources',
        adminLoading: 'Loading admin permissions',
        adminError: 'Failed to load admin permissions',
        adminErrorDesc: 'The permission service could not provide the current staff member’s admin menus.',
      },
    },
    Workspace: {
      title: 'Tenant Workspace',
      logoAlt: 'Workspace',
      staffFallback: 'Tenant staff',
      expand: 'Expand menu',
      collapse: 'Collapse menu',
      notice: 'Notifications',
      personalMenu: 'Personal menu',
      personalMenuEmpty: 'No personal menu is available',
      menuLoading: 'Loading workspace and personal menus',
      menuSubtitle: 'The first-level workspace navigation is driven by the current staff workspace permissions.',
      menuError: 'Failed to load workspace menus',
      menuErrorDesc: 'Please check the staff session, tenant ID, and gateway availability.',
      menuEmpty: 'No workspace menu is visible to the current staff member',
      current: 'Current',
      entryReady: '{{name}} is ready',
      eLearningUnavailable: 'E-learning is not available yet',
      eLearningUnavailableDesc: 'This route is recognized, but its business page has not been migrated. Return to the workspace.',
      eLearningBack: 'Back to workspace',
    },
    ELearningReview: {
      status: {
        approved: 'Approved',
        assigned: 'Assigned',
        cancelled: 'Cancelled',
        failed: 'Failed',
        planCompleted: 'Ended',
        taskCompleted: 'Submitted',
        expired: 'Expired',
        inProgress: 'In progress',
        notStarted: 'Not started',
        overdue: 'Overdue',
        pendingApproval: 'Pending approval',
        pendingTask: 'Not submitted',
        rejected: 'Rejected',
        returned: 'Returned',
        suspended: 'Suspended',
        unassigned: 'Unassigned',
        withdrawn: 'Withdrawn',
      },
      planDetail: 'Plan details',
      taskDetail: 'Task details',
      retry: 'Retry',
      detailLoadFailed: 'Failed to load details',
      courseTag: 'course tag',
      keyword: 'keyword',
      emptyDetail: 'No details',
      planName: 'Plan name',
      planStatus: 'Plan status',
      taskProgress: 'Task completion',
      startDate: 'Start date',
      endDate: 'End date',
      completed: 'Completed',
      unsubmitted: 'Not submitted',
      inReview: 'In review',
      rejected: 'Rejected',
      planRemark: 'Plan description',
      tags: 'Tags',
      taskList: 'Tasks ({{count}})',
      emptyTasks: 'No tasks',
      taskName: 'Task name',
      resourceName: 'Resource name',
      reviewer: 'Reviewer',
      submissionStatus: 'Submission status',
      approvalStatus: 'Approval status',
      remark: 'Remark',
      attachments: 'Attachments',
      participating: 'Participating',
      followed: 'Managed and followed',
      uncompleted: 'Incomplete',
      expiredCurrent: 'Expired (current query)',
      totalTasks: 'Total tasks',
      totalCompletedTasks: 'Completed tasks',
      totalProgress: 'Overall completion',
      taskKeyword: 'Enter task name',
      allTaskStatus: 'All task statuses',
      allApprovalStatus: 'All approval statuses',
      planKeyword: 'Enter plan name',
      allPlanStatus: 'All plan statuses',
      allProgress: 'All progress',
      query: 'Search',
      reset: 'Reset',
      listLoadFailed: 'Failed to load review list',
      sourcePlan: 'Source plan: {{name}}',
      timeRange: 'Period: {{start}} - {{end}}',
      goToReview: 'Go to review',
      withdrawReview: 'Withdraw review',
      withdrawReviewTitle: 'Confirm withdrawal',
      withdrawReviewConfirm: 'Withdraw this approval?',
      withdrawReviewSucceeded: 'Withdrawn successfully',
      withdrawReviewFailed: 'Failed to withdraw',
      viewDetail: 'View details',
      emptyParticipating: 'No participating tasks',
      emptyFollowed: 'No followed plans',
      noData: 'No data',
      content: 'Review content',
      reviewRecord: 'Review record',
      cancel: 'Cancel',
      confirm: 'Confirm',
      approvalMismatch: 'Approval does not match the review task',
      approvalMismatchDesc: 'The approval ID in this link does not belong to this review task. All write actions are disabled. Return to the audit center and reopen it.',
      submitConfirm: 'Submit this review and start approval?',
      submitReview: 'Submit review',
      withdrawConfirm: 'Withdraw this review approval?',
      withdraw: 'Withdraw approval',
      approveConfirm: 'Approve this review?',
      approve: 'Approve',
      rejectAction: 'Reject',
      rejectTitle: 'Reject review approval',
      rejectPlaceholder: 'Enter a rejection reason',
    },
    Interaction: {
      title: 'Resource Space',
      noAccess: 'No access',
      noAccessDescription: 'This account cannot access any Resource Space page',
      loadFailed: 'Resource Space failed to load',
      menu: {
        groups: {
          personal: 'Personal Space',
          school: 'School Space',
        },
        routes: {
          myExam: 'Questions',
          myFile: 'Resource Materials',
          myNote: 'Notes',
          myVideo: 'Course Recordings',
          schoolExam: 'School Question Bank',
          schoolResource: 'School Resources',
        },
      },
      common: {
        all: 'All',
        cancel: 'Cancel',
        confirm: 'Confirm',
        retry: 'Retry',
        edit: 'Edit',
        publish: 'Publish',
        delete: 'Delete',
        download: 'Download',
        close: 'Close',
        loading: 'Loading',
        nextPage: 'Next page',
        pageNumber: 'Page {{page}}',
        previousPage: 'Previous page',
        source: 'Source',
        empty: 'No data',
        resetFilters: 'Reset filters',
        searchContent: 'Search with AI',
        resourceLoadFailed: 'Failed to load resources. Please retry.',
        networkFailed: 'Network connection failed. Please retry.',
        noAvailableTextbook: 'No available textbook is configured for this account',
        chapterDirectoryLoadFailed: 'Failed to load the chapter directory',
        uploadFailed: 'Upload failed',
        registrationUnknown: 'The business registration result is unknown',
        invalidFileType: 'Invalid file type',
        uploadCredentialFailed: 'Failed to get upload credentials',
        uploadHTTPFailed: 'Upload failed: HTTP {{status}}',
        uploadNetworkFailed: 'Network error. Upload failed.',
        selectAvailableTextbook: 'Select an available textbook',
      },
      resourceSelector: {
        allCategories: 'All categories',
        category: 'Category',
        categoryLoadFailed: 'Failed to load resource categories. Please retry.',
        completeTextbook: 'Select a stage, subject, textbook version, and textbook',
        currentPath: 'Current path',
        directoryEmpty: 'No available directories in this scope',
        directoryLoadFailed: 'Failed to load the resource directory. Please retry.',
        fileSize: 'Size',
        noAvailableTextbook: 'No textbook is available for this account',
        personalEmpty: 'No selectable resources in this folder',
        personalListLoadFailed: 'Failed to load personal resources. Please retry.',
        personalRoot: 'Personal file root',
        personalSpace: 'Personal Space',
        publishedAt: 'Published at',
        resourceMaterial: 'Resource Materials',
        resourceName: 'Resource name',
        resourceType: 'Resource type',
        schoolEmpty: 'No selectable school resources in this directory',
        schoolListLoadFailed: 'Failed to load school resources. Please retry.',
        schoolResource: 'School Resources',
        schoolSpace: 'School Space',
        searchResource: 'Search by resource name',
        selectDirectory: 'Select a directory',
        selectedCount: '{{count}} resources selected',
        selectStage: 'Select a stage',
        selectSubject: 'Select a subject',
        selectTextbook: 'Select textbook',
        selectTextbookPlaceholder: 'Select a textbook',
        selectTextbookVersion: 'Select a textbook version',
        stage: 'Stage',
        subject: 'Subject',
        switchTextbook: 'Switch textbook',
        syncResource: 'Synchronized Resources',
        teachingOptionsLoadFailed: 'Failed to load textbook options. Please retry.',
        textbook: 'Textbook',
        textbookVersion: 'Textbook version',
        title: 'Select resources',
        topicLoadFailed: 'Failed to load topics. Please retry.',
        unconfiguredTextbook: 'No textbook configured',
        updatedAt: 'Updated at',
      },
      exam: {
        addTitle: 'Add questions',
        addSucceeded: 'Question added successfully',
        addingHint: 'Adding 1 question. Composite questions can contain subquestions.',
        approvalPending: 'Approval request submitted and awaiting review',
        batchDelete: 'Batch delete',
        cannotClearChildTeaching: 'All teaching tags on an existing subquestion cannot be cleared at once',
        cannotClearRootTeaching: 'All teaching tags on an existing question cannot be cleared at once',
        childCustomTagsBlocked: 'This subquestion has custom tags, so its teaching information cannot be changed at the same time',
        creationPayloadLocked: 'The add result is unconfirmed. Refresh the personal question bank; this payload is locked.',
        creationReviewed: 'Reviewed; allow another submission',
        creationStillUnknown: 'This add result is still unconfirmed. Refresh the personal question bank before continuing.',
        creationUnknown: 'The add result is unknown. Refresh your personal question bank to verify it.',
        deleteConfirm: 'Delete the selected questions?',
        deleteFailed: 'Failed to delete questions',
        deleteQuestion: 'Delete question',
        deleteRetry: 'Failed to delete questions. Please retry.',
        deleteSucceeded: 'Questions deleted successfully',
        detailLoadFailed: 'Failed to load question details. Please retry.',
        editRequestFailed: 'Failed to submit the question edit request',
        editSucceeded: 'Question updated successfully',
        editTitle: 'Edit question',
        editingHint: 'Editing 1 question',
        title: 'Questions',
        search: 'Search question text',
        kind: 'Question type',
        difficulty: 'Difficulty',
        stage: 'Stage',
        grade: 'Grade',
        subject: 'Subject',
        knowledge: 'Knowledge point',
        year: 'Year',
        itemsPerPage: '/ page',
        invalidQuestionID: 'Invalid question ID',
        listLoadFailed: 'Failed to load the personal question bank. Please retry.',
        missingPublishMetadata: 'Question “{{name}}” needs both textbook chapters and knowledge points before publishing.',
        publishFailed: 'Failed to submit approval. Please retry.',
        publishPayloadLocked: 'The approval result is unconfirmed. Refresh the review center; this payload is locked.',
        publishStillUnknown: 'This approval result is still unconfirmed. Check the review center before continuing.',
        publishValidationFailed: 'Failed to validate publishing requirements. Please retry.',
        requestUnconfirmed: 'The request result is unconfirmed. Refresh to verify it.',
        rootCustomTagsBlocked: 'This question has custom tags, so its teaching information cannot be changed at the same time',
        saveFailed: 'Failed to save the question. Please retry.',
        saveChanges: 'Save changes',
        saveQuestion: 'Save question',
        selectAnswer: 'Select an answer',
        selectDifficulty: 'Select a difficulty',
        selectOneQuestion: 'Select at least one question',
        selectTopicNodeFirst: 'Select a topic node first',
        selectYear: 'Select a year',
        totalItems: '{{total}} items',
        batchActions: 'Batch actions',
        add: 'Add question',
        empty: 'No questions',
        publishTitle: 'Publish questions',
        normalPublishHint: 'Normal publishing uses the textbook chapters and knowledge points already assigned to each question.',
        choiceJudge: 'Choice and judgment',
        content: 'Question content',
        contentPlaceholder: 'Enter the question content',
        option: 'Options',
        optionPlaceholder: 'Enter option content',
        analysis: 'Explanation',
        analysisPlaceholder: 'Enter the question explanation',
        advancedFields: 'Full question fields',
        mediaHint: 'Manage images and attachments in the full question fields',
        insertImage: 'Upload image',
        selectorSearch: 'Search question text',
        selectorEmpty: 'No questions available',
        selectorLoadFailed: 'Failed to load the personal question bank',
        answer: 'Answer',
        collapseDetails: 'Collapse details',
        correct: 'Correct',
        difficultyNames: {
          easy: 'Easy',
          hard: 'Hard',
          normal: 'Medium',
        },
        expandDetails: 'Expand details',
        incorrect: 'Incorrect',
        kindNames: {
          blank: 'Fill in the blank',
          calc: 'Calculation',
          cloze: 'Cloze',
          drawing: 'Drawing',
          essay: 'Essay',
          inquiry: 'Inquiry',
          judge: 'True or false',
          matching: 'Matching',
          multi: 'Multiple choice',
          ordering: 'Ordering',
          reading: 'Reading comprehension',
          short: 'Short answer',
          single: 'Single choice',
        },
        leftColumn: 'Left column',
        noAnalysis: 'No explanation.',
        rightColumn: 'Right column',
        sourceNames: {
          personal: 'Personal question bank',
          platform: 'Platform resources',
          school: 'Saved from school',
        },
        teachingNames: {
          grade: {
            'junior-1': 'Grade 7',
            'junior-2': 'Grade 8',
            'junior-3': 'Grade 9',
            'junior54-1': 'Grade 6',
            'junior54-2': 'Grade 7',
            'junior54-3': 'Grade 8',
            'junior54-4': 'Grade 9',
            'primary-1': 'Grade 1',
            'primary-2': 'Grade 2',
            'primary-3': 'Grade 3',
            'primary-4': 'Grade 4',
            'primary-5': 'Grade 5',
            'primary-6': 'Grade 6',
            'primary54-1': 'Grade 1',
            'primary54-2': 'Grade 2',
            'primary54-3': 'Grade 3',
            'primary54-4': 'Grade 4',
            'primary54-5': 'Grade 5',
            'secondary-vocational-1': 'Vocational Year 1',
            'secondary-vocational-2': 'Vocational Year 2',
            'secondary-vocational-3': 'Vocational Year 3',
            'senior-1': 'Grade 10',
            'senior-2': 'Grade 11',
            'senior-3': 'Grade 12',
          },
          stage: {
            high: 'Senior high school',
            junior: 'Junior high school',
            junior54: 'Four-year junior high school',
            kindergarten: 'Kindergarten',
            primary: 'Primary school',
            primary54: 'Five-year primary school',
            'secondary-vocational': 'Secondary vocational school',
            senior: 'Senior high school',
            'special-education': 'Special education',
          },
          subject: {
            art: 'Arts',
            biology: 'Biology',
            chemistry: 'Chemistry',
            chinese: 'Chinese',
            english: 'English',
            geography: 'Geography',
            history: 'History',
            information: 'Information Technology',
            japanese: 'Japanese',
            math: 'Mathematics',
            music: 'Music',
            paint: 'Fine Arts',
            physics: 'Physics',
            politics: 'Ideology and Politics',
            science: 'Science',
            sports: 'Physical Education and Health',
            technology: 'General Technology',
          },
        },
        listSeparator: ', ',
        noSelectedQuestions: 'No questions selected. Add questions first.',
        publishApprovalStarted: 'Publishing approval has started. Check progress in the review center.',
        publishReviewed: 'Reviewed; allow another submission',
        publishSucceeded: 'Published successfully',
        publishToTopic: 'Publish to topic resources',
        publishTopicHint: 'Without a topic, questions must have textbook chapters and knowledge points. Selecting a topic allows direct approval submission.',
        publishUnknown: 'The approval result is unknown. Check it in the review center first.',
        selectedQuestionCount: '{{count}} questions selected',
        selectedTopicNodes: 'Selected topic nodes: {{names}}',
        untitledQuestion: 'Untitled question',
        updatedAt: 'Updated at {{time}}',
        editor: {
          addBlank: 'Add blank',
          addChild: 'Add subquestion',
          addClozeBlank: 'Add blank',
          addItem: 'Add option',
          addKnowledge: 'Add knowledge points',
          addMatchingRow: 'Add row',
          addOrderingItem: 'Add ordering item',
          addTextbookChapters: 'Add textbook chapters (optional, multiple)',
          analysisPlaceholder: 'Enter the explanation; image uploads are supported',
          answerLabels: {
            drawing: 'Reference drawing',
            essay: 'Reference approach',
            short: 'Reference answer',
          },
          answerPlaceholder: 'Enter {{label}}; image uploads are supported',
          blankAnswerPlaceholder: 'Answer for blank {{index}}',
          blankAnswers: 'Blank answers',
          blankIndex: 'Blank {{index}}',
          chapterLoading: 'Loading chapters...',
          childContent: 'Subquestion {{index}} stem',
          childContentPlaceholder: 'Enter the stem for subquestion {{index}}',
          childIndex: 'Subquestion {{index}}',
          childKind: 'Question type for subquestion {{index}}',
          children: 'Subquestions',
          clozeOptions: 'Blank options',
          contentLabels: {
            content: 'Question content',
            passage: 'Passage',
            readingMaterial: 'Reading material',
            stem: 'Stem',
            writingRequirements: 'Writing requirements',
          },
          contentPlaceholders: {
            blank: 'Enter the question and use Insert blank to add blanks.',
            calc: 'Enter the problem context and add subquestions below.',
            cloze: 'Paste the passage and insert blanks where needed.',
            drawing: 'Enter the drawing instructions and add the initial diagram.',
            essay: 'Enter the writing prompt, materials, and word limit.',
            inquiry: 'Enter the inquiry context, conditions, and diagrams.',
            judge: 'Enter a true-or-false statement.',
            matching: 'Enter the matching instructions.',
            multi: 'Enter a multiple-choice question.',
            ordering: 'Enter the ordering instructions.',
            reading: 'Paste the reading passage and add illustrations if needed.',
            short: 'Enter a short-answer question.',
            single: 'Enter a single-choice question.',
          },
          correctAnswer: 'Correct answer',
          deleteBlank: 'Delete blank {{index}}',
          deleteChild: 'Delete subquestion {{index}}',
          deleteOption: 'Delete option {{option}}',
          deleteOrderingItem: 'Delete ordering item {{option}}',
          dragOrderingItem: 'Drag ordering item {{option}}',
          dragToReorder: 'Drag to reorder',
          fillOption: 'Enter option',
          groups: {
            choice: 'Choice and judgment',
            composite: 'Composite',
            fill: 'Fill in the blank',
            interactive: 'Interactive',
            other: 'Other',
            subjective: 'Subjective',
          },
          kindNames: {
            blank: 'Fill-in-the-blank question',
            calc: 'Calculation question',
            cloze: 'Cloze',
            drawing: 'Drawing question',
            essay: 'Essay question',
            inquiry: 'Inquiry',
            judge: 'True-or-false question',
            matching: 'Matching question',
            multi: 'Multiple-choice question',
            ordering: 'Ordering question',
            reading: 'Reading comprehension',
            short: 'Short-answer question',
            single: 'Single-choice question',
          },
          imageOptions: 'Image options',
          imageOnly: 'Only image files are supported',
          imageUploadFailed: 'Failed to upload the image. Please retry.',
          insertBlank: 'Insert blank',
          leftPlaceholder: 'Enter left-column content',
          matchingAnswer: 'Match for item {{index}}',
          matchingItems: 'Matching items',
          materialLoading: 'Loading textbooks...',
          moveChildDown: 'Move subquestion {{index}} down',
          moveChildUp: 'Move subquestion {{index}} up',
          optionImageAlt: 'Option {{option}}',
          optionImagePlaceholder: 'Upload image',
          orderingPlaceholder: 'Enter ordering content',
          question: 'Question',
          rightPlaceholder: 'Enter right-column content',
          selectMaterials: 'Select textbooks',
          selectPlaceholder: 'Select',
          setAsAnswer: 'Set as answer',
          setBlankAnswer: 'Set {{option}} as the answer for blank {{blank}}',
          sortItems: 'Ordering items',
          teachingInfo: 'Teaching information',
          textbookChapters: 'Textbook chapters',
          textOptions: 'Text options',
          unmatched: 'Unmatched',
          unset: 'Not set',
        },
      },
      folder: {
        currentTarget: 'Current target: {{path}}',
        root: 'My resources',
        namePlaceholder: 'New folder name',
        submitCreate: 'Create',
        cancel: 'Cancel',
        create: '+ New folder',
        empty: 'No subfolders in this folder',
        cannotSelectSelf: ' (cannot select itself or descendants)',
      },
      file: {
        alreadyInTarget: 'The selected files are already in the target folder',
        actions: 'Actions',
        addedResourceCount: '{{count}} resources added',
        approvalSubmitted: 'Submitted for approval',
        batchDelete: 'Batch delete',
        batchPublish: 'Batch publish',
        archiveProcessing: 'The folder archive is being prepared. Export again later.',
        cannotClearTeachingTags: 'The backend cannot reliably clear all teaching tags. Keep at least one or cancel editing.',
        copiedCount: '{{count}} items copied',
        copyPartialUnknown: '{{count}} items were copied, but the current result is unknown. Further copies stopped; refresh the target folder.',
        copyStillUnknown: 'Some selected files have unconfirmed copy results. Refresh the target folder and verify before continuing.',
        copySucceeded: 'Copied successfully',
        copyUnknown: 'The copy result is unconfirmed. Refresh the target folder; this operation is locked to prevent duplicates.',
        createFolderFailed: 'Failed to create folder',
        createFolderSucceeded: 'Folder created successfully',
        createdAs: 'Created as {{name}}',
        customTagsBlocked: 'This file has custom tags, so its teaching information cannot be changed at the same time',
        deleteConfirm: 'This action cannot be undone. Continue?',
        deleteFailed: 'Delete failed',
        deleteFile: 'Delete file',
        deleteSucceeded: 'Deleted successfully',
        document: 'Documents',
        earliestModified: 'Oldest modified',
        export: 'Export',
        exportPreparationFailed: 'Failed to prepare the folder export',
        exportPreparationRetry: 'Failed to prepare the export. Please retry.',
        file: 'File',
        folderLoadFailed: 'Failed to load folders. Please retry.',
        folderNamePlaceholder: 'Enter a folder name',
        image: 'Images',
        itemsPerPage: '/ page',
        media: 'Audio and video',
        modifiedAt: 'Modified at',
        moreActions: 'More actions for {{name}}',
        mountChapterFirst: 'Attach textbook chapters first',
        name: 'Name',
        newFolder: 'New folder',
        operationSucceeded: 'Operation succeeded',
        other: 'Other',
        personalRoot: 'My resources',
        personalUpload: 'Personal upload',
        preview: 'Preview',
        publishToTopic: 'Publish to topic resources',
        publishTopicHint: 'Without this option, resources are published to their attached chapters. Enable it to select additional topic nodes.',
        recentlyModified: 'Recently modified',
        remove: 'Remove',
        rename: 'Rename',
        editMountedChapters: 'Edit attached chapters',
        editMountedChaptersFailed: 'Failed to update attached chapters',
        editMountedChaptersSucceeded: 'Attached chapters updated successfully',
        editMountedChaptersTitle: 'Edit attached chapters - {{name}}',
        save: 'Save',
        schoolSync: 'Synchronized school resources',
        selectFilesFirst: 'Select files to operate on first',
        selectedResourceCount: '{{count}} resources selected',
        selectTopicFirst: 'Select a topic first',
        selectTopicNodes: 'Select topic nodes across one or more topics',
        selectTopics: 'Select topics',
        size: 'Size',
        sizeExceeded: '{{type}} cannot exceed {{limit}}. Select another file.',
        teachingInfo: 'Teaching information',
        totalItems: '{{total}} items',
        uploadResource: 'Upload resources',
        uploadDropMultiple: 'Drag files here or click to select multiple files',
        videoFile: 'Video file',
        batchActions: 'Batch actions',
        listView: 'List view',
        sort: 'Sort',
        resourceNamePlaceholder: 'Enter a resource name',
        summary: 'Resource summary',
        remark: 'Notes',
        clearTagsBlocked: 'The current backend cannot reliably clear all teaching tags. Only confirmed fields will be saved.',
        copyTo: 'Copy to',
        copyHint: 'The current contract supports one item at a time; duplicate names receive an automatic suffix.',
        moveTo: 'Move to',
        moveBlocked: 'The server does not yet recheck target ownership and ancestor loops during writes, so moving is disabled.',
        publishTitle: 'Publish',
        publishHint: 'A valid accessible category is required. The backend has no idempotency request ID, so unknown results are not retried automatically.',
        publishCategory: 'Select a publishing category',
        publishChapterHint: 'Existing teaching chapters are submitted with the resource; the server rechecks category and tenant scope.',
        uploadDrop: 'Click or drag files here to upload',
        uploadPath: 'Upload folder: {{path}}',
        selectedSubfolder: 'Selected subfolder',
        uploadRegistrationUnknown: 'Some file registrations have an unknown result. Refresh the current folder before retrying.',
        commonSummary: 'Shared resource summary',
        commonRemark: 'Shared notes',
        uploadHint: 'At most three uploads run concurrently. Remove and reselect failed S3 uploads.',
        addResource: 'Add resources',
        selectorTip: 'Only files are shown. Folders are used for navigation.',
        selectorSearch: 'Search resource names',
        selectorEmpty: 'No files are available in this folder',
        selectorLoadFailed: 'Failed to load resources. Please retry.',
        selectedResources: 'Added resources',
        selectedTip: 'Selections are preserved when changing folders',
        clearSelected: 'Clear all',
        selectedEmpty: 'No resources added',
        uploadPathLabel: 'Upload path',
        downloadWindowBlocked: 'The browser blocked the download window. Allow pop-ups and retry.',
        folderNameRequired: 'Folder name is required',
        listLoadFailed: 'Failed to load personal files. Please retry.',
        movedCount: '{{count}} items moved',
        moveFailed: 'Move failed. Please retry.',
        movePartialFailed: '{{count}} items moved, but a later move failed. Refresh and retry.',
        movePartialUnknown: '{{count}} items moved, but the current result is unknown. Further moves stopped; refresh to verify.',
        moveSucceeded: 'Moved successfully',
        moveUnknown: 'The move result is unconfirmed. Refresh to verify it.',
        noPublishableFiles: 'The selection contains no publishable files',
        publishApprovalSubmitted: 'Publishing approval submitted for {{count}} resources',
        publishPayloadLocked: 'The approval result is unconfirmed. Check the review center; this payload is locked.',
        publishStillUnknown: 'This approval result is still unconfirmed. Check the review center before continuing.',
        registrationStillUnknown: 'Registration for “{{name}}” is still unconfirmed. Refresh the target folder before continuing.',
        registrationUnconfirmed: 'File registration is unconfirmed. Refresh the folder before continuing.',
        renamedAs: 'Renamed to {{name}}',
        renameFailed: 'Rename failed',
        renameSucceeded: 'Renamed successfully',
        requestUnconfirmed: 'The request result is unconfirmed. Refresh to verify it.',
        resourceMissingChapter: 'Resource “{{name}}” has no attached chapter. Configure it in Edit attached chapters before publishing.',
        selectEntriesFirst: 'Select files or folders first',
        selectPublishCategoryForEach: 'Select a publishing category for every resource',
        selectTopicResourceNodeFirst: 'Select a topic resource node first',
        siblingPaginationStalled: 'Sibling file pagination did not advance',
        siblingQueryFailed: 'Failed to query sibling files',
        targetLoadFailed: 'Failed to load the target folder. Please retry.',
        uploadSucceeded: 'Resources uploaded successfully',
        waitForUploads: 'Wait for all uploads to finish. Remove and reselect failed files.',
      },
      note: {
        collapseSidebar: 'Collapse sidebar',
        expandSidebar: 'Expand sidebar',
        create: 'New note',
        moreActions: '{{title}}, more actions',
        delete: 'Delete note',
        deleteTitle: 'Delete “{{title}}”?',
        deleteContent: 'This cannot currently be undone. Unsaved changes will also be discarded.',
        deleteSucceeded: 'Note deleted',
        deleteFailed: 'Failed to delete the note. Please retry.',
        deleteUnknown: 'The delete result is unconfirmed. Refresh the list to verify it.',
        selectFirst: 'Select a note to start editing',
        assistant: 'AI Assistant',
        title: 'Note title',
        bodyPlaceholder: 'Enter note content…',
        saveFailedRetry: 'Save failed. Retry',
        helpful: 'Helpful',
        unhelpful: 'Not helpful',
        prompt: 'Enter a question',
        stop: 'Stop',
        send: 'Send',
        optimizationAssistant: 'Note improvement assistant',
        closeOptimizationAssistant: 'Close note improvement assistant',
        optimizationPrompt: 'Describe how you want to improve this note...',
        group: {
          today: 'Today',
          recent: 'Last 30 days',
          earlier: 'Earlier',
        },
        noAdditionalText: 'No additional text...',
        unnamed: 'Untitled note',
        untitled: 'Untitled note',
        optimizationPromptEmpty: 'Please improve “{{title}}” with clearer structure and more accurate wording.',
        optimizationPromptWithContent: 'Please improve “{{title}}” while preserving its meaning and clarifying its structure, wording, and key points:\n{{content}}',
        imageOnly: 'Only image files are supported',
        imageSizeExceeded: 'Images cannot exceed 10 MB',
        imageURLMissing: 'The image uploaded successfully but no accessible URL was returned',
        titleSaveFailed: 'Failed to save the title',
        bodySaveFailed: 'Failed to save the note body',
        saveStillFailed: 'The note still could not be saved. Retry or explicitly discard the changes.',
        previousCreationUnknown: 'The previous creation result is unknown. Check the refreshed note list first.',
        creationUnknownRefreshed: 'The creation result is unknown. The list was refreshed; verify it before creating again.',
        creationFailed: 'Failed to create the note',
        creationReviewed: 'Reviewed; allow creation again',
        creationUnknownVerify: 'The creation result is unknown. Check the refreshed list to see whether the note was created.',
        aiIntro: 'I can improve the structure, extract key points, polish the wording, and produce a clearer version of this note.',
        startOptimization: 'Improve the current note',
        thinking: 'Thinking…',
        noReply: 'No response generated',
        retryAnswer: 'Retry answer',
        retrySync: 'Retry sync',
        regenerate: 'Regenerate',
        stayOnCurrent: 'Stay on this note',
        saveFailureContent: 'The latest content is unsaved. Retry saving, stay on this note, or explicitly discard the changes.',
        discardAndLeave: 'Discard changes and leave',
        retrySave: 'Retry save',
        saveFailed: 'Failed to save the note',
        detailLoadFailed: 'Failed to load note details',
        aiSessionMismatch: 'This AI conversation is not an Eino session for the current assistant, so it cannot be continued.',
        aiUnavailableForTenant: 'No AI assistant is available for this organization',
        aiConversationSyncFailed: 'Failed to retrieve the AI conversation',
        aiConversationScopeFailed: 'AI conversation scope validation failed. Refresh and retry syncing.',
        aiMessageSyncFailed: 'Failed to retrieve AI messages',
        aiReplyNotPersisted: 'This response has not finished persisting',
        aiConversationValidationFailed: 'AI conversation validation failed',
        aiConversationScopeChanged: 'The AI conversation scope changed. Refresh and reopen the note.',
        aiConversationIDMissing: 'The AI service did not return a conversation ID that can be retrieved',
        aiConversationInitFailed: 'Failed to initialize the conversation. Please retry.',
        aiReplyStopped: 'The response was stopped. Retry with the same request.',
        aiUnavailable: 'The AI assistant is temporarily unavailable',
      },
      work: {
        analyze: 'AI analysis',
        addExisting: 'Add existing work',
        search: 'Search work title',
        visibility: 'Visibility',
        empty: 'No work can be added',
      },
      video: {
        detail: 'Details',
        taskName: 'Enter task name',
        category: 'Select category',
        uploadFile: 'Upload file',
        workActions: 'Work actions',
        batchDelete: 'Batch delete',
        uploadTitle: 'Upload video',
        selectMp4: 'Select MP4 file',
        title: 'Video title',
        summary: 'Summary',
        remark: 'Notes',
        categoryField: 'Category',
        courseKind: 'Course type',
        lecturer: 'Lecturer',
        uploadCover: 'Upload cover',
        uploadAttachment: 'Upload attachment',
        uploadFailureHint: 'Remove and reselect failed uploads. Unknown registration results are not retried automatically.',
        noPreview: 'No video URL is available for preview',
        editTitle: 'Edit video',
        replaceCover: 'Replace cover',
        manageAttachments: 'Manage attachments',
        recording: 'Recording',
        recordingSearch: 'Search recording name',
        recordingRetentionPrefix: 'Temporary recordings are retained for ',
        recordingRetentionSuffix: ' days. Unprocessed recordings do not use personal storage.',
        cancelSelection: 'Cancel selection',
        batchDeleteRecording: 'Batch delete',
        batchDeleteRecordingConfirm: 'Delete the selected recordings?',
        deleteRecordingConfirm: 'This action cannot be undone. Delete this recording?',
        deleteRecordingLabel: 'Delete {{name}}',
        deleteRecording: 'Delete recording',
        noRecordingFile: 'No recording files',
        selectPlayableStream: 'Select a playable video stream',
        videoFile: 'Video',
        cover: 'Cover',
        coverURLPlaceholder: 'Enter a network image URL (http/https)',
        useURL: 'Use URL',
        lecturerPlaceholder: 'Select a lecturer',
        name: 'Name',
        namePlaceholder: 'Enter a video resource name',
        summaryPlaceholder: 'Enter a summary',
        createTimePlaceholder: 'Select creation time',
        classTime: 'Class time',
        classTimePlaceholder: 'Select a start time',
        categoryPlaceholder: 'Select a category',
        advancedFields: 'Additional course information and attachments',
        attachment: 'Attachments',
        videoList: 'Videos',
        creatorCenter: 'Creator Center',
        kindTeaching: 'Teaching class',
        kindResearch: 'Teaching research',
        kindOther: 'Other',
        courseFamousTeacher: 'Master teacher class',
        courseFamousSchool: 'Model school class',
        courseSpecial: 'Dedicated class',
        courseTeacherTraining: 'Teacher training',
        courseOnlineResearch: 'Online teaching research',
        sourceLocalUpload: 'Local upload',
        sourceRecording: 'Saved recording',
        sourceResource: 'Saved resource',
        statusCancelled: 'Cancelled',
        statusCompleted: 'Generated',
        statusFailed: 'Generation failed',
        statusInProgress: 'Generating',
        statusPending: 'Waiting to generate',
        statusReady: 'Ready',
        resourceInfo: 'Resource information',
        createTime: 'Created at',
        className: 'Class',
        actions: 'Actions',
        deleteConfirm: 'Delete the selected videos?',
        deleteVideo: 'Delete video',
        deleteLabel: 'Delete {{name}}',
        newWork: 'Create work',
        selectVideoFirst: 'Select classroom recordings first',
        selectDeleteFirst: 'Select items to delete first',
        itemsPerPage: '/ page',
        totalRecords: '{{count}} records',
        unnamedRecording: 'Untitled recording',
        recordingTime: 'Recorded at',
        lessonCategory: 'Course category',
        classType: 'Class type',
        status: 'Status',
        expiration: 'Expiration',
        expired: 'Expired',
        notExpired: 'Not expired',
        durationReadFailed: 'Unable to read the video duration',
        mp4Only: 'Only MP4 files are supported',
        durationReadRetry: 'Unable to read the video duration. Select the MP4 again.',
        imageOnly: 'Only image files are supported',
        reupload: 'Upload again',
        selectOrDragVideo: 'Select or drag a video file here',
        currentCoverURL: 'Current cover URL: {{url}}',
        courseKindPlaceholder: 'Select a course type',
        videoDetail: 'Video details',
        unknown: 'Unknown',
        save: 'Save',
        transfer: 'Transfer',
        recordingTimeValue: 'Recorded at: {{value}}',
        lecturerValue: 'Lecturer: {{value}}',
        classValue: 'Class: {{value}}',
        transferExpiredBlocked: 'This recording has expired and can no longer be saved or retried',
        transferIncompleteBlocked: 'This recording can be saved after generation is complete',
        streamName: 'Video stream {{index}}',
        retryStarted: 'Retry started',
        transferStarted: 'Transfer started',
        recordingProcess: 'Recording processing',
        refreshStatus: 'Refresh status',
        allStages: 'All stages',
        noUnselectedWork: 'No unselected work',
        addExistingDescription: 'Select one or more existing works and add the current classroom recordings. Filter by title, subject, or stage.',
        selectStage: 'Select a stage',
        allVisibility: 'All visibility scopes',
        visibilityInternal: 'My organization',
        visibilityCross: 'My organization and external organizations',
        visibilityPublic: 'Public on the internet',
        selectVisibility: 'Select visibility',
        availableWork: 'Available work',
        invertSelection: 'Invert selection',
        selectedWork: 'Selected work',
        clear: 'Clear',
        noSelectedWork: 'No work selected. Select work from the left.',
        networkURLApplied: 'Network URL applied',
        invalidNetworkURL: 'Enter a valid network URL',
        coverNetworkURLRequired: 'Enter a cover image URL',
        continueEditing: 'Continue editing',
        closeUnsavedContent: 'The work form has unsaved changes that will be lost when it closes.',
        discardChanges: 'Discard changes',
        closeUnsavedTitle: 'Close the work form?',
        leaveUnsavedContent: 'The work form has unsaved changes that will be lost when you leave.',
        leaveUnsavedTitle: 'Leave the work form?',
        selectPublishRecordingFirst: 'Select classroom recordings to publish first',
        acceptUploadAgreement: 'Accept the Resource Upload Service Agreement first',
        agreementPrefix: 'I have read and agree to the ',
        uploadAgreement: 'Resource Upload Service Agreement',
        publishWork: 'Publish work',
        creationReviewed: 'Reviewed; allow registration again',
        creationUnknownLocked: 'The work registration result is still unconfirmed. Check the Creator Center; this payload is locked.',
        publishTo: 'Publish to',
        featuredClassroom: 'Cloud Teaching Community · Featured Classrooms',
        featuredClassroomDescription: 'Classroom works shared with teachers appear in Featured Classrooms and can be found by stage and subject.',
        visibility: 'Visibility',
        visibilityDescription: 'This only controls visibility in the Cloud Teaching Community and does not change the original personal resource permissions.',
        selectExternalTenant: 'Select external organizations',
        workInfo: 'Work information',
        workInfoDescription: 'Students and teachers use this information to find and filter the classroom work.',
        workName: 'Work name',
        workNamePlaceholder: 'Enter a work name (up to 50 characters)',
        workSummaryPlaceholder: 'Enter a summary (up to 300 characters)',
        type: 'Type',
        selectType: 'Select a type',
        selectCategoryFirst: 'Select a category first',
        selectSubject: 'Select a subject',
        selectStageFirst: 'Select a stage first',
        textbookVersion: 'Textbook edition',
        selectTextbook: 'Select a textbook',
        selectKnowledge: 'Select knowledge points',
        selectedRecordings: 'Selected classroom recordings',
        selectFromPersonalRecordings: 'Select from Personal Recordings',
        add: '+ Add',
        selectRecording: 'Select classroom recordings',
        selectedVideoCount: '{{count}} videos selected',
        listLoadFailed: 'Failed to load videos. Please retry.',
        latestDetailLoadFailed: 'Failed to load the latest video details. Editable list data was preserved.',
        invalidCoverURL: 'Enter a valid http/https cover image URL',
        registrationStillUnknown: 'The video registration result is unknown. Refresh the list before removing and selecting the file again.',
        waitForVideoUpload: 'Wait for the video upload to finish. Remove and reselect failed files.',
        registrationUnknown: 'The video registration result is unconfirmed. Refresh the list before continuing.',
        uploadSucceeded: 'Video uploaded successfully',
        nameRequired: 'Video name is required',
        editFailed: 'Failed to edit the video',
        editRequestFailed: 'The edit request failed. Keep the current content and retry.',
        editSucceeded: 'Video updated successfully',
        selectDeleteVideo: 'Select videos to delete',
        deleteFailed: 'Delete failed',
        deleteUnknown: 'The delete result is unconfirmed. Refresh the list to verify it.',
        deleteSucceeded: 'Deleted successfully',
        completeUploadRequiredFields: 'Complete the lecturer, name, category, and corresponding course type',
        completeEditRequiredFields: 'Complete the lecturer, category, and corresponding course type',
        waitForSupportingUploads: 'Wait for cover and attachment uploads to finish',
        recordingListLoadFailed: 'Failed to load recordings. Please retry.',
        recordingDetailLoadFailed: 'Failed to load recording details. Please retry.',
        transferStillUnknown: 'The transfer result is still unconfirmed. Refresh the details before continuing.',
        recordingFileProcessing: 'This recording file is being processed. Please wait.',
        transferUnknown: 'The transfer result is unconfirmed. Refresh the status before continuing.',
        selectRecordingDeleteFirst: 'Select recordings to delete',
        deleteProcessing: 'The delete request is being processed. Please wait.',
        deleteRetry: 'Delete failed. Please retry.',
        deleteSucceededRefreshFailed: 'Deleted successfully, but the list failed to refresh. Please retry.',
        existingWorkPartialFailed: 'Some works could not be updated. Please retry.',
        existingWorkPublishFailed: 'Failed to add the recordings to the selected works. Please retry.',
        existingWorkPublished: 'Added to the selected works',
        creationStillUnknown: 'The registration result is still unconfirmed. Check the Creator Center before continuing.',
        creationUnknown: 'The registration result is unconfirmed. Check the Creator Center before continuing.',
        workEditFailed: 'Failed to save the latest work changes. Please retry.',
        workDraftSaved: 'Work draft saved',
        workPublishFailed: 'Publishing failed. The draft was preserved and can be retried.',
        workPublished: 'Work submitted for publishing',
        existingWorkLoadFailed: 'Failed to load existing work. Please retry.',
        selectExistingWork: 'Select existing work',
        attachmentName: 'Attachment {{index}}',
      },
      schoolExam: {
        addToPersonal: 'Add to personal question bank',
        chapterLoadFailed: 'Failed to load chapters',
        cloneComingSoon: 'Adding questions to your personal question bank is coming soon',
        defaultTeachingMissing: 'No default stage and subject are configured for this account',
        title: 'School Question Bank',
        syncTab: 'Synchronized Resources',
        knowledgeTab: 'Knowledge Points',
        knowledgeLoadFailed: 'Failed to load knowledge points',
        listTruncated: 'Too many results. Narrow the filters to load the complete question structure.',
        navigationLoadFailed: 'Failed to load navigation',
        navigationLoading: 'Loading directory',
        reselectStageSubject: 'Select stage and subject again',
        searchAction: 'Search',
        selectDirectory: 'Select a directory',
        selectMaterial: 'Select a textbook',
        selectStageSubject: 'Select a stage and subject',
        selectStageSubjectTitle: 'Select stage and subject',
        switchMaterial: 'Switch textbook',
        textbookChapters: 'Textbook chapters',
        topicDirectory: 'Topic directory',
        topicDirectoryLoadFailed: 'Failed to load the topic directory',
        topicQuestionBank: 'Topic question bank',
        topicQuestionBankLoadFailed: 'Failed to load the topic question bank',
        underConstruction: 'Coming soon',
        unconfiguredMaterial: 'No textbook configured',
        updatedAtEmpty: 'Updated at -',
        cloneBlocked: 'The backend does not yet provide a school-question clone contract',
        empty: 'No school questions',
        previousBatch: 'Previous batch',
        nextBatch: 'Next batch',
        batchLabel: 'Batch {{batch}}',
      },
      schoolResource: {
        chapterLoadFailed: 'Failed to load chapters',
        cloneFailed: 'Failed to save the resource. Please try again later.',
        cloneRenamed: 'Saved as “{{name}}”. Check it in your personal resources.',
        cloneSuccess: 'Saved to personal resources',
        cloneUnconfirmed: 'The result is unconfirmed. Refresh personal resources before retrying.',
        contentSwitching: 'Switching content',
        createFolderFailed: 'Failed to create the folder. Please try again later.',
        createFolderRetry: 'Creation failed. Please try again later.',
        navigationLoading: 'Loading directory',
        notFound: 'Resource not found',
        personalLibrary: 'Personal resources',
        preview: 'Preview',
        resourceLoading: 'Loading resources',
        selectAvailableMaterial: 'Select an available textbook',
        selectChapter: 'Select a chapter',
        selectTopicDirectory: 'Select a topic directory',
        syncTab: 'Synchronized resources',
        targetLoadFailed: 'Failed to load personal folders',
        teachingNavigationFailed: 'Failed to load the teaching directory',
        textbookChapters: 'Textbook chapters',
        title: 'School Resources',
        publishedAt: 'Published at {{time}}',
        publishedAtEmpty: 'Published at -',
        empty: 'No school resources',
        selectMaterial: 'Select textbook',
        cloneTitle: 'Save to personal resources',
        cancel: 'Cancel',
        confirm: 'Confirm',
        personalRoot: 'My resources',
        newFolder: 'New folder',
        folderNamePlaceholder: 'Enter a folder name',
        topicDirectory: 'Topic directory',
        topicNavigationFailed: 'Failed to load the topic directory',
        topicResource: 'Topic resources',
        untitled: 'Untitled resource',
      },
      teaching: {
        stage: 'Stage',
        subject: 'Subject',
        material: 'Textbook',
        chapter: 'Chapter',
        knowledge: 'Knowledge point',
        knowledgeBlocked: 'The file contract has no knowledge-point field. Stage, subject, and chapter can be saved, but knowledge points cannot be fabricated.',
        version: 'Select a version',
        mountChapter: 'Attach chapters',
        materialVersion: 'Version',
        selectKnowledge: 'Select knowledge points',
        selectMaterial: 'Select a textbook',
        selectMaterialFirst: 'Select a textbook first',
        selectStage: 'Select a stage',
        selectStageSubjectFirst: 'Select a stage and subject first',
        selectSubject: 'Select a subject',
        singleResourceHint: 'A single resource can use only one stage and subject. Select a textbook before its chapters; only the selected textbook directory is loaded.',
        volume: 'Volume',
      },
    },
    Official: {
      nav: { products: 'Features', help: 'Help' },
      actions: { workspace: 'Enter Smart Education Space', signedIn: 'Signed in' },
      sections: {
        product: 'Seamless learning online and in class',
        learning: 'Stay in control before and after class',
        aiGrowth: 'Unlimited growth powered by AI',
        management: 'Smarter decisions, simpler management',
        solutions: 'Balanced education through connected solutions',
      },
      product: {
        digital: { title: 'Digital Classroom', desc: 'Bring up to a thousand participants together with adaptive networking and flexible 180P–1080P video for smooth collaboration wherever teaching happens.' },
        board: { title: 'Shared Whiteboard', desc: 'Connect classrooms so teachers and students can write together and share documents, desktops, and presentations without barriers.' },
        save: { title: 'Save and Share', desc: 'Save and share multi-screen whiteboards so knowledge stays available after class.' },
      },
      learning: {
        schedule: { title: 'Flexible Scheduling', desc: 'Coordinate timetables across devices and visualize teacher and student availability to start classes or teaching meetings from any screen.' },
        analysis: { title: 'Class Analysis', desc: 'Turn classroom interaction and learning performance into clear data that pinpoints the moments that matter.' },
        eLearning: { title: 'Featured Courses', desc: 'Build lasting district and school teaching libraries through automatic uploads, layered management, and precise search.' },
      },
      ai: {
        teacher: { title: 'AI Teacher Assistant', subtitle: 'An always-on general assistant', desc: 'Smart reminders, workflow coordination, and data summaries reduce routine workload while supporting goals and growth.' },
        professional: { title: 'AI Professional Assistant', subtitle: 'A teaching and research assistant that understands you', desc: 'Use natural language to call teaching resources and tools based on both instructions and intent.' },
      },
      management: {
        supervision: { title: 'Continuous, unobtrusive supervision', desc: 'Inspect multiple classrooms remotely, keep feedback traceable, and make everyday teaching supervision measurable.' },
        dashboard: { title: 'A complete view of campus data', desc: 'Aggregate core campus indicators in real time and connect related metrics to uncover management insight.' },
        devices: { title: 'Central device control', desc: 'Control campus devices remotely, receive automatic fault alerts, and respond quickly while reducing maintenance cost.' },
      },
      solutions: {
        remote: { title: 'Remote Interactive Classroom', desc: 'Deliver high-quality teaching from central schools to remote campuses in real time so more students can share the same cloud classroom.' },
        resources: { title: 'Regional Resource Sharing', desc: 'Connect and preserve quality teaching resources so they circulate efficiently throughout a region.' },
        support: { title: 'Targeted Teaching Support', desc: 'Connect teaching data, identify weak areas, and improve overall quality through instruction tailored to learner needs.' },
      },
      help: { docs: 'Documentation', service: 'Customer Service' },
      footer: 'Connect every classroom to a wider world of teaching resources.',
    },
  },
} as const;
